import { injectPersonalData } from '../pages/impressum/impressumUtils.js';

const baseTranslationPL = {
  title: 'Nota prawna',
  subtitle: 'Informacje zgodnie z § 5 DDG (niemieckiej ustawy o usługach cyfrowych)',
  serviceProvider: 'Usługodawca',
  contactTitle: 'Kontakt',
  addressLabel: 'Adres',
  contactLabel: 'Adres e-mail',
  professionalTitle: 'Informacje o spółce',
  professionLabel: 'Forma prawna',
  businessTypeLabel: 'Rodzaj działalności',
  taxTitle: 'Informacje podatkowe',
  liabilityTitle: 'Informacja o odpowiedzialności',
  contentLiabilityTitle: 'Odpowiedzialność za treści',
  contentLiability: 'Jako usługodawca odpowiadamy za własne treści na tych stronach zgodnie z § 7 ust. 1 DDG na zasadach ogólnych. Zgodnie z §§ 8-10 DDG jako usługodawca nie jesteśmy jednak zobowiązani do monitorowania przekazywanych lub przechowywanych cudzych informacji ani do badania okoliczności wskazujących na działalność niezgodną z prawem.',
  linkLiabilityTitle: 'Odpowiedzialność za linki',
  linkLiability: 'Nasza oferta zawiera linki do zewnętrznych stron internetowych osób trzecich, na których treść nie mamy wpływu. Dlatego nie możemy przyjąć odpowiedzialności za te cudze treści. Za treść stron, do których prowadzą linki, odpowiada zawsze ich dostawca lub operator. W chwili umieszczenia linków strony te zostały sprawdzone pod kątem ewentualnych naruszeń prawa. Treści niezgodnych z prawem wówczas nie stwierdzono.',
  copyrightTitle: 'Prawa autorskie',
  copyright: 'Treści i utwory stworzone przez operatora tych stron podlegają niemieckiemu prawu autorskiemu. Powielanie, opracowywanie, rozpowszechnianie oraz wszelkie wykorzystanie wykraczające poza granice prawa autorskiego wymagają pisemnej zgody autora lub twórcy. Pobieranie i kopiowanie tych stron jest dozwolone wyłącznie do użytku prywatnego, niekomercyjnego.'
};

export const localePL = {
  nav: {
    title: 'pAIoneer Labs GmbH', home: 'Strona główna', team: 'Zespół', events: 'Wydarzenia', finance: 'AI w finansach', teaching: 'Szkolenia',agenticdev: 'IDD / Agentic Coding', iddLegacy: 'Modernizacja starszego oprogramowania', iddMethod: 'Intent-Driven Development', veridion: 'Veridion', kyveil: 'Anonimizacja', quantum: 'Kwantowe',login: 'Zaloguj się',
    openApp: 'Otwórz aplikację',
    account: 'Konto',
    admin: 'Administracja',
    logout: 'Wyloguj się',
    languageNames: { en: 'Angielski', de: 'Niemiecki', nl: 'Niderlandzki', uk: 'Ukraiński', fr: 'Francuski', it: 'Włoski', es: 'Hiszpański', sv: 'Szwedzki', fi: 'Fiński', ja: 'Japoński', pl: 'Polski', bg: 'Bułgarski' }
  },
  admin: {
    datalake: {
      loading: "Wczytywanie …",
      loadFailed: "Data lake jest nieosiągalny",
      refresh: "Odśwież",
      generatedAt: "Stan na",
      notRolled: "Ten obszar nie został jeszcze wdrożony w backendzie. Gdy tylko nowe endpointy będą dostępne, pojawi się tu zmierzony stan.",
      loadMore: "Wczytaj więcej",
      yes: "tak",
      no: "nie",
      none: "brak",
      close: "Zamknij",
      summaryTitle: "Dwie hipotezy, jeden warsztat",
      summaryBody: "Hipoteza architektury mówi: matematyczne naczynie decyduje, czym model może się stać — znajduje się na stronie artykułu LLM. Hipoteza danych mówi: dopiero powiązane, zweryfikowane dane treningowe wypełniają to naczynie — tej hipotezie służy ta strona. Autopilot stale wypełnia zasób danych, uruchamia trening, gdy plan danych z artykułu jest osiągnięty w każdej dziedzinie po niemiecku i angielsku, mierzy wynik zestawem benchmarków i publikuje model prywatnie na HuggingFace. Każda liczba tutaj jest zmierzona albo oznaczona jako wartość skonfigurowana.",
      summaryArchButton: "Do hipotezy architektury (artykuł LLM)",
      apTitle: "Autopilot",
      tpTitle: "Droga do startu treningu",
      tpSubtitle: "Gdzie jest teraz autopilot: każdy krok aż do działającego treningu ze stanem, czasem i postępem.",
      tpNow: "Teraz",
      tpStep: "Krok",
      tpOf: "z",
      tpSince: "od",
      tpFor: "trwa od",
      tpHeartbeat: "ostatni sygnał życia",
      tpDone: "gotowe",
      tpRunning: "trwa",
      tpWaiting: "czeka",
      tpFailed: "nieudane",
      tpSkipped: "pominięte",
      tpProgress: "Postęp",
      tpRows: "wierszy",
      tpRate: "na sekundę",
      tpRemaining: "szacowany pozostały czas",
      tpEstimateNote: "szacunek z mierzonych liczników",
      tpPhaseReading: "czyta pakiet danych",
      tpPhaseAdmission: "dopuszczenie (duplikaty, entropia)",
      tpPhaseEncoding: "tokenizacja",
      tpNoTiming: "Ta wersja silnika nie raportuje jeszcze czasów.",
      tpBlockers: "Blokady i błędy",
      tpNone: "Brak blokad.",
      trTitle: "Przebieg treningu (na żywo)",
      trSubtitle: "Odczytywane bezpośrednio z katalogu przebiegu trenera — działa także podczas restartu workera.",
      trNoRun: "Brak jeszcze przebiegu treningu z danymi o postępie.",
      trStateTraining: "trenuje",
      trStateStarting: "uruchamia się",
      trStateFinished: "zakończony",
      trStateSilent: "cisza od {age}",
      trStep: "Krok",
      trOf: "z",
      trRemaining: "Pozostały czas (szacunek na podstawie zmierzonej szybkości)",
      trSecondsPerStep: "s na krok",
      trProgress: "Postęp zaplanowanych kroków",
      trRun: "Przebieg",
      trResumed: "wznowiony od kroku {step}",
      trVersion: "Wersja danych treningowych",
      trModel: "Model",
      trTokensPerSecond: "Tokeny/s",
      trTokensSeen: "Przetworzone tokeny",
      trVram: "Pamięć GPU",
      trCap: "limit",
      trLastHeartbeat: "Ostatni heartbeat",
      trAgo: "{age} temu",
      trShardReads: "Odczyty shardów lokalnie / przez workera",
      trLossTitle: "Przebieg straty (loss)",
      trLossTotal: "Łącznie",
      trLossNtp: "Następny token",
      trLossMtp: "Wiele tokenów",
      trChartEmpty: "Nie zgłoszono jeszcze żadnych kroków.",
      trAxisNote: "Poziomo: krok treningu, pionowo: strata (logarytm naturalny). Najedź kursorem na krzywą, aby zobaczyć wartości kroku.",
      trValue: "Wartość",
      trCurrentValue: "bieżąca",
      trPoints: "łącznie {count} punktów pomiarowych",
      trStages: "Etapy programu nauczania",
      trStageFoundation: "Fundament (surowy tekst)",
      trStageCapability: "Umiejętności",
      trStageAnneal: "Anneal",
      trStageCurrent: "trwa",
      trStageDone: "zakończony",
      trStageAhead: "przed nami",
      trShards: "shardów",
      trRows: "wierszy",
      trCheckpoint: "Najnowszy checkpoint",
      trCheckpointNone: "jeszcze brak",
      trCheckpoints: "Kompletne checkpointy na dysku",
      trCheckpointEvery: "co {minutes} min",
      trKernels: "Aktywne kernele",
      trDeviations: "Odchylenia",
      trBlockStorage: "Kopia w block storage",
      trBlockStorageNone: "jeszcze brak — pierwsza po pierwszym checkpoincie",
      trUploading: "wysyłanie: krok {step}",
      treeCkRun: "Przebieg treningu",
      treeCkCopy: "Checkpoint w block storage, skopiowany {time}",
      treeCkLocal: "Checkpoint na dysku serwera",
      treeCkUploading: "właśnie kopiowany do block storage",
      trKpiProgress: "Postęp",
      trKpiTokens: "Tokeny",
      trKpiThroughput: "Przepustowość",
      trKpiLoss: "Strata",
      trKpiLr: "Współczynnik uczenia",
      trKpiGpu: "Pamięć GPU",
      trEndAt: "koniec ok. {time}",
      trSeenPlanned: "przetworzone / zaplanowane",
      trBest: "najlepsza {value}",
      trHourAgo: "{value} wzgl. 1 h temu",
      trPerplexity: "perpleksja {value}",
      trPhaseWarmup: "rozgrzewka",
      trPhaseCosine: "spadek kosinusowy",
      trPhaseStable: "faza stabilna",
      trPhaseDecay: "schładzanie",
      trKpiEpoch: "Epoka",
      trEpochValue: "{epoch} z {epochs}",
      trPlanTitle: "Plan przebiegu",
      trPlanExplain: "Rozgrzewka do szczytowego tempa uczenia, potem stałe tempo przez cztery mieszane epoki korpusu; faza schładzania trenuje na najwyższej jakości mieszance (próbki umiejętności, teksty podręcznikowe, anneal) i obniża tempo uczenia do zera.",
      trPlanPhase: "Faza",
      trPlanStableSteps: "Planowane kroki fazy stabilnej",
      trPlanDecay: "Schładzanie",
      trPlanDecayAhead: "od kroku {step} · za około {time}",
      trPlanDecayAheadNoTime: "od kroku {step}",
      trPlanDecayRunning: "od kroku {step} · {steps} kroków do tempa uczenia zero",
      trPlanTokensPerStep: "Tokeny na krok optymalizacji",
      trPlanTokensPerStepValue: "{tokens} ({accum} mikropartii)",
      trPlanRecompute: "Ponowne obliczanie aktywacji",
      trPlanRecomputeOn: "włączone – zmierzone jako szybsze przy większej mikropartii",
      trPlanRecomputeOff: "wyłączone – zmierzone jako szybsze bez",
      trPlanFim: "Dokumenty w formie fill-in-the-middle do tej pory",
      tbTitle: "Program podręcznikowy",
      tbSubtitle: "Teksty foundation przepisane przez modele-nauczycieli jako tekst podręcznikowy; każda liczba i każda nazwa własna musi występować w źródle.",
      tbTokens: "Tokeny podręcznikowe",
      tbTokensSub: "{pct} % celu {target}",
      tbSamples: "Przyjęte przeróbki",
      tbJobs: "Ukończone zadania",
      tbTeacher: "Tokeny nauczyciela na token podręcznikowy",
      tbCost: "Koszt na milion tokenów podręcznikowych",
      tbCostNone: "bramka nie zgłasza kosztów; liczone są tokeny nauczyciela",
      tbExplain: "Działa równolegle z treningiem; późniejsze epoki i schładzanie czytają to, co do tego czasu zostało zapieczętowane.",
      trThroughputTitle: "Przepustowość (tokeny/s)",
      trCurriculumTitle: "Program nauczania",
      trStageTokens: "{tokens} tokenów",
      trStageBegins: "zaczyna się od kroku {step}",
      trPlanWarningLabel: "Uwaga",
      trPlanWarning: "Przebieg kończy się po {max} krokach w etapie „{stage}” — dane umiejętności zaczynają się dopiero od kroku {cap}. Pełne przejście wymagałoby {steps} kroków (≈ {days} dni).",
      trPlanOk: "Zaplanowane kroki sięgają etapu „{stage}”.",
      trCheckpointsTitle: "Checkpointy",
      trNextCheckpoint: "Następny checkpoint",
      trInSpan: "za {span}",
      trResumes: "Wznowienie",
      trNoResume: "brak",
      trConfig: "Konfiguracja",
      trHealth: "Stan",
      trMicroBatch: "Mikro-partia / tokeny na krok",
      trSeqLen: "Długość sekwencji",
      trLrPlan: "Plan współczynnika uczenia",
      trLrPlanValue: "szczyt {lr}, rozgrzewka {warmup} kroków, kosinus do kroku {max}",
      trSpikes: "Skoki straty (ostatnia godzina)",
      trProgressSub: "krok {step} z {max} · trenuje od {elapsed}",
      trTokensSub: "z {planned} zaplanowanych",
      trPathTrainingDetail: "{pct} % · krok {step} z {max} · koniec ok. {end}",
      trReadinessRunning: "Trening trwa: {pct} % gotowe (krok {step} z {max}), strata {loss}, koniec ok. {end}.",
      tdvDraftsHistory: "Starsze szkice, nigdy niezapieczętowane ({count})",
      runsHistory: "Przerwane i nieudane przebiegi ({count})",
      trAxisStep: "Krok treningu",
      trAxisLoss: "Strata (logarytm naturalny)",
      trCountdown: "{d} d {h} h {m} min {s} s",
      trTimerWaiting: "Zegar pojawi się po pierwszych pomiarach.",
      trTimerStageEnds: "Etap „{stage}” kończy się za",
      trTimerAt: "o {time}",
      trTimerNext: "Potem „{stage}”: {span}, od {time}",
      trTimerRunEnds: "Przebieg kończy się za {span} (o {time})",
      trStepTimeSub: "{wall} s na krok (pomiar) · obliczenia {compute} s",
      trEtaTitle: "Pozostały czas z mierzonego czasu kroku",
      trEtaEpochEnds: "Epoka {epoch} z {epochs} kończy się za",
      trEtaEpochAt: "o {time} (krok {step})",
      trEtaNextEpoch: "Epoka {epoch}: od {time} (krok {step})",
      trEtaDecay: "Faza schładzania zaczyna się za {span} (o {time}, krok {step})",
      trEtaBasis: "Podstawa: {wall} s na krok, średnia z ostatnich {n} kroków bez {pauses} przerw (restart, przestój); czas obliczeń według trenera {compute} s na krok.",
      devTitle: "Odchylenia od projektu",
      devNone: "Brak odchyleń — przebieg w pełni podąża za projektem.",
      devPlanned: "planowane",
      devLimit: "ograniczenie",
      devSeqLen: "Długość kontekstu",
      devSeqLenText: "Trenowanie z kontekstem {trained} tokenów zamiast {spec} przewidzianych w projekcie. Długi kontekst dojdzie w późniejszej fazie.",
      devFim: "Wypełnianie luk (FIM)",
      devFimText: "Cel wypełniania luk ({rate} % bloków) jest zadeklarowany w projekcie, ale w tym przebiegu jeszcze nieaktywny.",
      devTermination: "Sonda zakończenia",
      devTerminationText: "Sonda zakończenia nie jest celem treningu, lecz osobnym trybem po treningu; uruchamiana później na gotowym checkpoincie.",
      devDecision: "Cel decyzyjny",
      devDecisionText: "Cel decyzyjny jest aktywny, ale w etapach po treningu tego przebiegu nie dotarły żadne znaczniki decyzji.",
      devKernelOff: "Przyspieszenie wyłączone",
      devKernelUnverifiedText: "Kernel „{kernel}” nie został potwierdzony przez sondę i działa jako obliczenie standardowe.",
      devKernelUnavailableText: "Kernel „{kernel}” nie jest dostępny na tej karcie i działa jako obliczenie standardowe.",
      devKernelFellBackText: "Kernel „{kernel}” wrócił w trakcie przebiegu do obliczenia standardowego ({reason}).",
      devOptimizer: "Optymalizator",
      devOptimizerText: "Stany optymalizatora są w bfloat16 zamiast 8 bitów (bitsandbytes niedostępne) — więcej pamięci, ta sama matematyka.",
      devScale: "Rozmiar modelu",
      devScaleText: "Model jest utworzony w {scale} % rozmiaru z projektu, bo pełny rozmiar nie zmieścił się w zmierzonej pamięci.",
      devMediaHeads: "Głowice mediów",
      devMediaHeadsText: "Głowice obrazu/dźwięku są niewytrenowane, bo dane nie zawierają tokenów mediów — zgodnie z planem dla nici tekstowej.",
      devVision: "Ścieżka obrazu",
      devVisionText: "Ścieżka obrazu jest zbudowana, ale trenowała na zerze obrazów, bo dane ich nie zawierają.",
      devOther: "Inne",
      trStageShare: "{pct} % tego etapu gotowe",
      cap_tool_calling: "Wywołania narzędzi",
      cap_deep_reasoning: "Głębokie wnioskowanie",
      cap_software_engineering: "Rozwój oprogramowania",
      cap_office_finance: "Biuro i finanse",
      cap_doc_understanding: "Rozumienie dokumentów",
      tpExplainThresholds: "Dla każdej umiejętności wybranej nici w data lake musi być dość zweryfikowanych przykładów. Cel i pomiar są tu podane dla każdej umiejętności.",
      tpThresholdsDetail: "{met} z {total} umiejętności osiągnęło cel",
      tpThresholdRow: "{measured} przykładów",
      tpForeignThresholds: "Nie dla tej nici: {list} — należy do innej nici i niczego nie blokuje.",
      tpStepTokenizerReleaseExplain: "Tokenizer zamienia tekst na liczby. Jest ustalany raz i zgłaszany architekturze, aby dane i model mówiły tym samym językiem.",
      tpStepTokenizeTdvExplain: "Wszystkie zweryfikowane przykłady są tłumaczone na ciągi liczb ustalonym tokenizerem.",
      tpStepTokenizeCorpusExplain: "Cały surowy tekst data lake jest tłumaczony na ciągi liczb — masa dla fundamentu.",
      tpStepTdvCreateExplain: "Ze wszystkich stokenizowanych danych składana jest stała wersja danych treningowych (TDV) z programem nauczania i zmierzoną liczbą tokenów.",
      tpStepTdvSealExplain: "Wersja staje się niezmienna i jest kopiowana z opisem do block storage.",
      tpStepCompatExplain: "Dwanaście reguł sprawdza, czy wersja i architektura pasują (tokenizer, długość kontekstu, cele, pamięć). Wszystkie muszą być zielone.",
      tpStepVramExplain: "Mierzy na karcie, czy jest dość wolnej pamięci GPU na zadeklarowane zapotrzebowanie.",
      tpVramDetail: "{free} GB wolne, {need} GB potrzebne",
      tpStepTrainStartExplain: "Autopilot uruchamia przebieg treningu, gdy tylko wszystkie warunki są spełnione.",
      tpStepTrainingExplain: "Przebieg trenuje samodzielnie z checkpointami co 30 minut i sam wznawia po każdej przerwie. Szczegóły na stronie „Trening i publikacja”.",
      tpVramRunning: "karta zajęta przez trwający trening (potrzeba {need} GB); spełnione przy starcie",
      trPathTrainingDetailNoEnd: "{pct} % · krok {step} z {max}",
      srTitle: "Gotowość danych według nici modelu",
      srSubtitle: "Gdy jedna nić trenuje, data lake dalej przygotowuje dane pozostałych — aż do ich własnej zapieczętowanej wersji, bez startu treningu.",
      srTrainingNow: "trenuje teraz",
      srSelected: "wybrana",
      srDataReady: "dane gotowe",
      srPreparing: "w przygotowaniu",
      srModalities: "wejście: {in} · wyjście: {out}",
      srThresholds: "cele: {met} z {total} osiągnięte",
      srCorpus: "Stokenizowany korpus",
      srCorpusValue: "{tokens} tokenów w {shards} pakietach danych",
      srVersion: "Najnowsza wersja",
      srNoVersion: "jeszcze brak",
      srLacking: "Brakuje jeszcze",
      srLacksNothing: "niczego — wersja czeka na swoją nić",
      srLackThresholds: "cele nieosiągnięte",
      srLackCodec: "kodek obrazu/dźwięku niewydany",
      srLackTokenizer: "tokenizer niezgłoszony",
      srLackVersion: "brak zapieczętowanej wersji",
      srSelectedNote: "Ta nić trenuje teraz; jej ścieżka jest powyżej.",
      srSelectedIdleNote: "Ta nić jest wybrana do następnego treningu; jej ścieżka jest powyżej.",
      srUnselectedNote: "Ta nić nie rozpoczyna treningu, dopóki wybrana jest inna — jej dane są mimo to w pełni przygotowywane.",
      modText: "tekst",
      modImage: "obraz",
      modAudio: "dźwięk",
      modVideo: "wideo",
      tpStepThresholds: "Osiągnięcie celów",
      tpStepPlan: "Osiągnięcie planu danych z artykułu",
      tpExplainPlan: "Artykuł określa, ilu unikalnych, zweryfikowanych tokenów potrzebuje każda dziedzina. Niemiecki i angielski niosą każdy co najmniej połowę; kod liczy się bez języka. Liczone są tokeny dopuszczone po usunięciu duplikatów, a nie surowe szacunki.",
      tpPlanDetail: "Osiągnięto {met} z {total} dziedzin",
      tpPlanRowLang: "{have} / {target} · niemiecki {de} / {half} · angielski {en} / {half}",
      tpPlanRowFree: "{have} / {target}",
      tpPlanOpen: "otwarte: {langs}",
      tpLangDe: "niemiecki",
      tpLangEn: "angielski",
      tpPlanProvisional: "Wstępnie policzone dotychczasowym tokenizerem; rozstrzyga nowo wytrenowany.",
      tpStepOwnTokenizer: "Własny tokenizer nici",
      tpStepOwnTokenizerExplain: "Nić trenuje z własnym tokenizerem, wyuczonym na zrównoważonym korpusie z kodem. Dopiero w jego tokenach plan danych liczy się ostatecznie.",
      tpPlanCat_knowledge: "Wiedza",
      tpPlanCat_code: "Kod",
      tpPlanCat_mathematics: "Matematyka",
      tpPlanCat_domain: "Teksty specjalistyczne",
      tpPlanCat_textbook: "Podręcznik",
      tpPlanCat_agentic: "Przykłady agentowe",
      tpPlanFlow: "napływ {rate} na godzinę",
      tpPlanEtaDays: "jeszcze około {n} dni",
      tpPlanEtaHours: "jeszcze około {n} godzin",
      tpPlanNoFlow: "brak napływu w ostatnich 24 godzinach",
      tpPlanBinding: "wąskie gardło",
      tpBind_download: "pobieranie",
      tpBind_allowance: "dzienny limit block storage",
      tpBind_ingest: "przyjmowanie",
      tpBind_teachers: "modele nauczycielskie",
      thrPlanTitle: "Przykłady według umiejętności (zmierzone)",
      thrPlanNote: "Cele tej nici wyznacza jej artykuł: plan danych dla każdej dziedziny, po niemiecku i angielsku, na drodze do startu treningu. Progi dla umiejętności dotyczą tylko nici bez planu danych; tu widać, co według pomiaru zawiera każda umiejętność.",
      thrPlanRow: "{samples} przykładów · {tokens} tokenów",
      srDataPlan: "Plan danych z artykułu: osiągnięto {met} z {total} dziedzin",
      srLackDataPlan: "plan danych nieosiągnięty",
      srPlanOpen: "otwarte: {areas}",
      tpBind_source: "brak źródła w tym języku",
      tpBind_paused: "pobieranie wstrzymane",
      tdvPlanEmpty: "Brak jeszcze wersji danych aktywnej specyfikacji. Autopilot zbuduje ją i zapieczętuje, gdy plan danych z artykułu zostanie osiągnięty.",
      compatPlanNone: "Brak jeszcze sprawdzenia: wersja aktywnej specyfikacji jest sprawdzana przy zapieczętowaniu.",
      mixPlanTitle: "Mieszanka według artykułu",
      mixPlanNote: "Każdy krok treningu pobiera dziedziny w tych stałych udziałach; faza wygaszania podnosi udział wysokiej jakości do połowy. Cele mieszanki dla umiejętności dotyczą tylko nici bez planu danych.",
      mixPlanShare: "{area} {pct} %",
      sitTitle: "Sytuacja",
      sitSubtitle: "Gdzie jest trening w jednym spojrzeniu: czego jeszcze brakuje w każdej dziedzinie artykułu, co teraz działa i co będzie dalej.",
      sitHeadlineDays: "Trening może ruszyć najwcześniej za około {time}; najdłużej trwa {area} (wąskie gardło: {bottleneck}).",
      sitHeadlineBlocked: "Tak planu danych się nie osiągnie: {items} nie ma źródła. Trwają prace: szukanie otwartych zbiorów albo sprawdzone tłumaczenie.",
      sitHeadlineReached: "Plan danych jest osiągnięty; dalej tokenizer, nowa tokenizacja, zapieczętowanie i sprawdzenia.",
      sitHeadlineUnknown: "Napływ reszty nie jest jeszcze zmierzony.",
      sitHold: "Start jest dodatkowo wstrzymany, dopóki każdy element nie zostanie sprawdzony.",
      sitArea: "Dziedzina",
      sitTotal: "Razem",
      sitFlow: "Napływ",
      sitLeft: "Zostało",
      sitBottleneck: "Wąskie gardło",
      sitNoLanguage: "bez języka",
      sitNoSource: "brak źródła",
      sitReached: "osiągnięte",
      sitDays: "{n} dni",
      sitHours: "{n} godz.",
      sitPerHour: "{value} na godzinę",
      sitPerHourTokens: "{value} tokenów na godzinę",
      sitRunningTitle: "Co teraz działa",
      sitDownloads: "Pobieranie",
      sitIngest: "Przetwarzanie na fragmenty tekstu",
      sitTokenize: "Tokenizacja",
      sitGenerate: "Generowanie przez modele nauczycielskie",
      sitIdle: "spoczynek",
      sitNextTitle: "Co dalej",
      sitNextSteps: "Trening tokenizera z kodem → ponowna tokenizacja całego korpusu → zapieczętowanie wersji → sprawdzenia → start treningu",
      sitProvisional: "Ilości są liczone wstępnie dotychczasowym tokenizerem; ostatecznie liczy nowo wytrenowany.",
      tpPlanSeeSituation: "Dziedziny, języki i pozostały czas są w sytuacji powyżej.",
      sitHeadlineBlocks: "Trening nie może jeszcze ruszyć: brakuje elementów, które trzeba dopiero zbudować ({items}). W tym czasie dane rosną.",
      sitDuration: "Czas treningu: około {days} dni dla {budget} tokenów przy zmierzonych {rate} tokenach na sekundę w tej samej sieci.",
      sitBlocksTitle: "Elementy treningu",
      sitStateNotBuilt: "jeszcze nie zbudowane",
      sitStateWaiting: "czeka",
      sitStateReady: "gotowe",
      sitBlockWaitsFor: "czeka na: {items}",
      sitBenchProgress: "{made} z {total} sprawdzonych zadań",
      sitBlockParts: "zbudowane: {built} · otwarte: {open}",
      part_graph_bundles: "powiązane dokumenty",
      part_repository_bundles: "całe repozytoria",
      part_long_context: "długi kontekst",
      part_fine_tuning: "dostrajanie",
      part_reinforcement_learning: "uczenie ze wzmocnieniem",
      part_real_folding: "rzeczywiste zwijanie kontekstu",
      sitBlock_data: "Dane według planu z artykułu",
      sitBlock_tokenizer: "Tokenizer z kodem",
      sitBlock_bench: "Zestaw benchmarków z artykułu",
      sitBlock_trainer: "Trener: etapy okna, stały budżet, stała mieszanka",
      sitBlock_bundles: "Pakiety: powiązane dokumenty i całe repozytoria",
      sitBlock_post_training: "Dotrenowanie: długi kontekst, dostrajanie, uczenie z nagrodą",
      tpStepTokenizerRelease: "Wydanie tokenizera",
      tpStepTokenizeTdv: "Tokenizacja przykładów treningowych",
      tpStepTokenizeCorpus: "Tokenizacja korpusu",
      tpStepTdvCreate: "Utworzenie wersji danych",
      tpStepTdvSeal: "Zapieczętowanie wersji danych",
      apAfterSealLabel: "Kontynuuj automatycznie po zapieczętowaniu",
      apAfterSealOn: "WŁ.",
      apAfterSealOff: "WYŁ.",
      apAfterSealConfirmOn: "Kontynuować automatycznie po zapieczętowaniu? Droga do startu treningu przebiega wtedy bez przerwy: kontrola zgodności, kontrole GPU i start treningu.",
      apAfterSealConfirmOff: "Ponownie zatrzymywać po zapieczętowaniu? Autopilot wstrzymuje się wtedy do przeglądu po zapieczętowaniu wersji danych.",
      apAfterSealTurnedOn: "Droga do startu treningu jest kontynuowana automatycznie po zapieczętowaniu.",
      apAfterSealTurnedOff: "Autopilot zatrzymuje się po zapieczętowaniu.",
      apAfterSealWaiting: "Wersja danych zapieczętowana – autopilot wstrzymany do przeglądu.",
      apAfterSealStep: "Przegląd zapieczętowanej wersji danych",
      apAfterSealHint: "Po zapieczętowaniu wszystkie dane leżą przetworzone w pamięci blokowej. Przy wyłączonym przełączniku autopilot wstrzymuje się tam do przeglądu; włączony – droga jest kontynuowana automatycznie.",
      tpStepCompat: "Kontrola zgodności",
      tpStepVram: "Test VRAM",
      tpStepTrainStart: "Start treningu",
      tpStepTraining: "Trening trwa",
      apSubtitle: "Jeden przełącznik dla całego cyklu: zbieranie, przetwarzanie i łączenie danych, generowanie przykładów, trening po osiągnięciu planu danych z artykułu, benchmarki i prywatna publikacja. Każda blokada jest nazwana zamiast ukryta.",
      apOn: "Autopilot WŁ",
      apOff: "Autopilot WYŁ",
      apTurnOn: "Włącz autopilota",
      apTurnOff: "Wyłącz autopilota",
      apConfirmOn: "Włączyć autopilota? Uzupełnia dane w sposób ciągły aż do zapieczętowanej wersji danych; potem wstrzymuje się do przeglądu, chyba że „Kontynuuj automatycznie po zapieczętowaniu” jest włączone.",
      apConfirmOff: "Wyłączyć autopilota? Trwająca praca kończy się w sposób kontrolowany; nic nie zostaje odrzucone.",
      apEnabled: "Autopilot włączony",
      apDisabled: "Autopilot wyłączony",
      apPause: "Wstrzymaj",
      apResume: "Wznów",
      apResumed: "Autopilot wznowiony",
      apPausedNote: "Autopilot wstrzymany",
      apPausedPill: "wstrzymany",
      apPhaseLabel: "Faza",
      apPhaseSince: "od {time}",
      apCycleId: "Cykl",
      apBlockedLabel: "Zablokowany",
      apCycleTitle: "Postęp bieżącego cyklu",
      apCycleEmpty: "Brak aktywnego cyklu.",
      colPhase: "Faza",
      colPending: "Oczekuje",
      colRunning: "W toku",
      colDone: "Gotowe",
      colFailed: "Nieudane",
      thrTitle: "Progi według zdolności",
      thrSubtitle: "Od tych ilości autopilot pieczętuje wersję danych treningowych i uruchamia trening; paski pokazują zmierzony postęp.",
      thrMet: "osiągnięty",
      thrNotMet: "otwarty",
      thrDefault: "wstępnie ustawiony standard",
      thrForeign: 'nie dla wybranego nurtu',
      staleSince: 'Worker chwilowo nie odpowiada — ostatni zmierzony stan z',
      staleHint: 'Autopilot działa dalej; widok odświeży się, gdy worker znów odpowie.',
      idxTitle: 'Indeks wektorowy i deduplikacja',
      idxSubtitle: 'Własny indeks HNSW jeziora do łączenia grafu oraz mierzone usuwanie zduplikowanych shardów chunków.',
      idxConfigured: 'Indeks skonfigurowany',
      idxReachable: 'Indeks osiągalny',
      idxPoints: 'Punkty indeksu',
      idxBackfill: 'Zasilanie z tabeli embeddingów',
      idxBackfillDone: 'zakończone',
      idxBackfillOpen: 'trwa / otwarte',
      ddLastPass: 'Ostatni przebieg deduplikacji',
      ddChecked: 'sprawdzone zasoby',
      ddDropped: 'usunięte zduplikowane shardy',
      ddRows: 'usunięte wiersze chunków',
      ddRemaining: 'pozostali kandydaci',
      ddNone: 'jeszcze brak przebiegu',
      gsTitle: 'Etapy grafu',
      gsSubtitle: 'Etapy teacher grafu — embedding i ekstrakcja twierdzeń — służą syntezie przykładów wyprowadzonej z grafu; dlatego pobierają chunki wszerz przez zasoby, w kolejności rang: ranga 0 dokumenty właściciela i importy z narzędzi, ranga 1 masa wiedzy eksperckiej (nauka, technika, książki, rozumowanie, German Commons, Wikipedia), ranga 2 tekst ogólny (Wikisource, Gutenberg, korpusy webowe, transkrypcje), ranga 3 kod (tylko embedding, nigdy ekstrakcja twierdzeń). Masa bazowa trafia do korpusu tokenów bez przebiegu teacher.',
      gsMeasuredAt: 'Zmierzono o',
      gsRanksTitle: 'Kolejność rang',
      gsRanksEmpty: 'Plan rang nie został jeszcze zgłoszony.',
      gsColRank: 'Ranga',
      gsColLabel: 'Klasa źródła',
      gsColSources: 'Źródła',
      gsColAssets: 'Zasoby',
      gsColPendingExtract: 'Oczekuje na ekstrakcję',
      gsColPendingEmbed: 'Oczekuje na embedding',
      gsRankOwner: 'Dokumenty właściciela i importy z narzędzi',
      gsRankExpert: 'Masa wiedzy eksperckiej',
      gsRankGeneral: 'Tekst ogólny',
      gsRankCode: 'Kod (tylko embedding)',
      gsRankShort: 'ranga {n}',
      gsLoopsTitle: 'Ostatnia runda każdej pętli',
      gsColLoop: 'Pętla',
      gsColSource: 'Źródło',
      gsColChunks: 'Chunki przetworzone',
      gsColClaims: 'Twierdzenia',
      gsColEdges: 'Krawędzie',
      gsColSeconds: 'Sekundy',
      gsColLast: 'Ostatnia runda',
      gsLoopEmbed: 'Embedding',
      gsLoopExtract: 'Ekstrakcja twierdzeń',
      gsLoopLink: 'Powiązanie',
      gsUngrounded: '{n} bez pokrycia',
      gsNoRound: 'jeszcze brak rundy',
      gsClaims: 'Twierdzenia łącznie',
      gsAssetsWithClaims: 'Zasoby z twierdzeniami',
      gsDangling: 'Osierocone węzły chunków',
      gsStuck: 'Zablokowane zasoby (w przetwarzaniu bez działającego ingestu)',
      gsConcurrency: 'Równoległość ekstrakcji',
      gsOrphansLast: 'Ostatni przebieg czyszczenia',
      gsOrphansNone: 'jeszcze brak przebiegu',
      gsOrphansStatusCleaned: 'wyczyszczono',
      gsOrphansDropped: 'usunięte węzły',
      gsOrphansRemaining: 'pozostało',
      gsOrphansHint: 'Nie ma tu nic do zrobienia: autopilot sam planuje ograniczony przebieg czyszczenia, dopóki istnieją węzły chunków bez sharda. Podsumowanie pokazuje ostatni przebieg.',
      thrSamplesBar: "Przykłady",
      thrTokensBar: "Tokeny (szacunek)",
      thrNoMinimum: "zmierzono, bez minimum",
      thrEditTitle: "Edytuj progi",
      thrEditSubtitle: "Zapis zastępuje wszystkie progi w całości; wstępnie ustawione standardy obowiązują tylko do chwili ustawienia tu własnych wartości.",
      thrMinSamples: "Min. przykłady",
      thrMinTokens: "Min. tokeny (szacunek)",
      thrEnabled: "aktywny",
      thrAdd: "Dodaj wiersz",
      thrSave: "Zapisz progi",
      thrSaved: "Progi zapisane",
      thrEmpty: "Nie zdefiniowano jeszcze progów — bez aktywnych progów autopilot niczego nie pieczętuje i zgłasza to jako blokadę.",
      capability: "Zdolność",
      modSignature: "Sygnatura",
      removeRow: "Usuń",
      budgetsTitle: "Budżety dzienne",
      budgetsSubtitle: "Zużycie wobec limitu według zakresu i dnia — budżety ograniczają wywołania nauczyciela i embeddingu.",
      budgetScope: "Zakres",
      budgetDay: "Dzień",
      budgetSpent: "Zużyte",
      budgetCap: "Limit",
      budgetsEmpty: "Nie zgłoszono budżetów.",
      eventsTitle: "Zdarzenia",
      eventsSubtitle: "Co autopilot ostatnio zrobił lub zgłosił, najnowsze najpierw.",
      eventsEmpty: "Brak zdarzeń.",
      storageTitle: "Chmura",
      storageSubtitle: "Połączenie z Block Storage i inicjalizacja struktury folderów — powtarzalna bez skutków ubocznych.",
      connect: "Połącz Block Storage",
      backendLabel: "Backend zimnego magazynu",
      backendBlockStorage: "Block Storage",
      backendLocal: "Pamięć lokalna",
      connectedLabel: "Połączenie",
      connectedYes: "połączono",
      connectedNo: "nie połączono",
      accountLabel: "Konto",
      signinValidUntil: "Logowanie ważne do",
      oauthClientLabel: "Klient OAuth",
      clientConfigured: "skonfigurowany",
      clientNotConfigured: "nieskonfigurowany",
      bootstrapRun: "Zainicjalizuj strukturę",
      bootstrapDone: "Inicjalizacja wykonana",
      bootstrapReportTitle: "Ostatnie uruchomienie",
      bootstrapNoRun: "W tej sesji nie wykonano jeszcze bootstrapu.",
      bootstrapLine: "Utworzone foldery: {folders} · pliki w zimnym magazynie: {files} · powtórzenie bez zmian: {idempotent}",
      treeTitle: "Drzewo folderów",
      treeSubtitle: "Drzewo jest wersjonowaną specyfikacją: tutaj definiujesz foldery, autopilot może tylko dodawać. Chronione foldery silnika i niepuste foldery silnik odrzuca z uzasadnieniem. W Block Storage usuwa się tylko według stałych reguł, na przykład starsze kopie checkpointów (dwie najnowsze zostają); podczas pełnego pobierania usunięcia i nadpisania czekają, aż się zakończy.",
      treeActiveVersion: "Aktywna wersja v{version}",
      treePath: "Ścieżka",
      treePurpose: "Przeznaczenie",
      treeCreatedBy: "Utworzył",
      treeShards: "Shardy",
      treeBytes: "Rozmiar",
      treeActions: "Akcje",
      treeRetire: "Wycofaj",
      treeRetired: "Folder wycofany",
      treeAddFolder: "Dodaj folder",
      treeFolderAdded: "Folder utworzony",
      treeVersionsTitle: "Wersje",
      treeEmpty: "Nie zdefiniowano jeszcze folderów.",
      treePlanned: "Zaplanowano — specyfikacja drzewa v{version}",
      treeFiles: "Pliki",
      treeSizesMeasured: "Rozmiary zmierzone {measured}; foldery, których katalog nie prowadzi, policzono ostatnio w Block Storage {walked}. 1 GB = 10⁹ bajtów.",
      treeSizesNoWalk: "Rozmiary zmierzone {measured}; folderów, których katalog nie prowadzi, jeszcze nie policzono. 1 GB = 10⁹ bajtów.",
      treeExpand: "Pokaż podfoldery ({count})",
      treeCollapse: "Ukryj podfoldery",
      treeShowMore: "Pokaż kolejne foldery ({count})",
      treeSourceCatalog: "Z katalogu: liczone są obiekty, które naprawdę leżą w Block Storage",
      treeSourceWalk: "Policzone podczas przeglądu Block Storage",
      bsUsageTitle: "Miejsce w Block Storage",
      bsUsageSubtitle: "Zajęte miejsce, limit i wolne miejsce konta Block Storage oraz udział data lake; wartości mają najwyżej dziesięć minut. 1 GB = 10⁹ bajtów.",
      bsUsed: "Zajęte",
      bsLimit: "Limit",
      bsFree: "Wolne",
      bsNoLimit: "bez stałego limitu",
      bsTrash: "W koszu",
      bsLake: "W tym data lake",
      bsLakeLine: "{size}, plików: {files} · {share} zajętego miejsca",
      bsMeasuredAt: "Zmierzono",
      bsNotConnected: "Block Storage nie jest połączony; miejsce pojawi się, gdy tylko połączenie zostanie nawiązane.",
      bsBarLake: "Data lake",
      bsBarOther: "Reszta konta",
      bsDlTitle: "Pełne pobieranie",
      bsDlSubtitle: "Pobiera cały Block Storage plik po pliku do tej samej struktury folderów, bez archiwum. Dopóki trwa, obowiązuje tryb ochrony: usunięcia i nadpisania ujętych plików czekają, aż się zakończy; nowe pliki są nadal zapisywane i nie należą do tego pobierania. Trwający trening nigdy nie jest spowalniany.",
      bsDlButton: "Pobierz cały Block Storage",
      bsDlFolderHint: "Raz wybierasz folder docelowy; tam powstają podfoldery. Pliki już kompletne są pomijane, przerwane są wznawiane od ich długości.",
      bsDlScriptHint: "Ta przeglądarka nie może zapisywać folderów. Otrzymujesz skrypt pobierania, który tworzy tę samą strukturę folderów i pobiera każdy plik z możliwością wznowienia.",
      bsDlWindowsNames: "Znaki, których Windows nie dopuszcza w nazwach (np. „>”), występują w folderze docelowym jako kod %, na przykład %3E.",
      bsDlActiveNote: "Pobieranie trwa od {time}. Przycisk powyżej kontynuuje je w tej przeglądarce; kompletne pliki są pomijane.",
      bsDlBuilding: "Lista plików jest tworzona: dotąd plików: {files}, {size}.",
      bsDlManifest: "Wczytywanie listy plików: {done} z {total} pozycji.",
      bsDlFolder: "Folder docelowy",
      bsDlFiles: "Pliki",
      bsDlData: "Dane",
      bsDlOf: "{done} z {total}",
      bsDlRate: "Szybkość",
      bsDlEta: "Pozostały czas",
      bsDlEtaUnknown: "obliczanie",
      bsDlCurrent: "Teraz pobierane",
      bsDlSkipped: "Pominięte, bo już kompletne: {count}",
      bsDlFailed: "Nieudane pliki: {count}",
      bsDlPausedNote: "Wstrzymano. Po wznowieniu rozpoczęte pliki są pobierane dalej od ich długości; tryb ochrony trwa, dopóki ta strona jest otwarta.",
      bsDlPause: "Wstrzymaj",
      bsDlContinue: "Wznów",
      bsDlRetryFailed: "Pobierz nieudane ponownie",
      bsDlFinish: "Zakończ",
      bsDlStop: "Zatrzymaj",
      bsDlStateBuilding: "lista plików w przygotowaniu",
      bsDlStateRunning: "pobiera",
      bsDlStatePaused: "wstrzymane",
      bsDlStateIncomplete: "niekompletne",
      bsDlStateScript: "skrypt gotowy",
      bsDlStateFinished: "zakończone",
      bsDlStateStopped: "przerwane",
      bsDlStateActive: "aktywne",
      bsDlFinished: "Wszystkie pliki ({files}, {size}) są w folderze docelowym; pobieranie zakończone.",
      bsDlFinishedNote: "Pobieranie zakończone; odroczone usunięcia i nadpisania są teraz wykonywane.",
      bsDlStopped: "Pobieranie zatrzymane; odroczone usunięcia i nadpisania są teraz wykonywane. Pobrane już pliki pozostają.",
      bsDlEnded: "Serwer zakończył pobieranie, na przykład po trzydziestu minutach bez oznak życia. Nowe kliknięcie uruchamia je ponownie; kompletne pliki są pomijane.",
      bsDlSession: "Sesja logowania wygasła. Zaloguj się ponownie; potem przycisk powyżej kontynuuje pobieranie.",
      bsDlDiskFull: "W folderze docelowym zabrakło miejsca. Zwolnij miejsce, a następnie wznów.",
      bsDlPickFailed: "Nie udało się otworzyć folderu docelowego.",
      bsDlScriptPosix: "Skrypt dla systemów Linux i macOS",
      bsDlScriptWindows: "Skrypt dla systemu Windows",
      bsDlScriptRun: "Zapisz skrypt w folderze docelowym i uruchom go tam: w systemie Windows dwukrotnym kliknięciem pliku .cmd lub z wiersza polecenia, w systemach Linux i macOS w terminalu poleceniem „sh <plik>”.",
      bsDlScriptKeyValid: "Klucz w skrypcie jest ważny do {time}, tylko dla tego pobierania i tylko do odczytu.",
      bsDlScriptHeartbeat: "Dopóki ta strona jest otwarta, informuje serwer, że pobieranie nadal trwa. Gdy skrypt skończy, kliknij „Zakończ”.",
      bsDlProtection: "Tryb ochrony",
      bsDlProtectionState: "Stan",
      bsDlProtectionOn: "aktywny od {time}",
      bsDlProtectionOff: "nieaktywny",
      bsDlScope: "Zakres pobierania",
      bsDlScopeValue: "plików: {files}, {size}",
      bsDlDeferredDeletes: "Odroczone usunięcia",
      bsDlDeferredOverwrites: "Odroczone nadpisania",
      bsDlAddedSince: "Dodane od startu",
      bsDlLastActivity: "Ostatni znak życia",
      acqTitle: "Źródła danych",
      acqSubtitle: "Kuratorowane źródła na otwartych licencjach: dla każdego licencja, ocena ochrony danych, język, modalność, cel bajtowy i zmierzony postęp. Wyłączone źródła podają swój powód, zamiast po cichu znikać.",
      acqGdprNote: "Zasada RODO: dane treningowe są dopuszczane wyłącznie ze źródeł z otwartą licencją i udokumentowaną oceną ochrony danych; dane ze skrzynki przechodzą czyszczenie PII przed utworzeniem przykładów (pokazuje to licznik „oczyszczone z PII”).",
      acqSource: "Źródło",
      acqModality: "Modalność · język",
      acqLicense: "Licencja",
      acqProtection: "Ochrona danych",
      acqProgress: "Postęp",
      acqDocs: "{count} plików/obiektów odebranych",
      acqTargetReached: "cel osiągnięty",
      acqExhausted: "źródło wyczerpane (listing nie dostarcza już niczego)",
      acqEnabledPill: "aktywne",
      acqWaitingBuffer: "czeka: bufor pełny, wysyłanie nadrabia",
      acqDisabledPill: "wyłączone",
      acqEnable: "Włącz",
      acqDisable: "Wyłącz",
      acqEnabledMsg: "Źródło włączone",
      acqDisabledMsg: "Źródło wyłączone",
      acqTargetLabel: "Cel (GB)",
      acqSetTarget: "Zapisz cel",
      acqTargetSaved: "Cel zapisany",
      acqEmpty: "Nie zarejestrowano jeszcze źródeł.",
      balanceTitle: "Równowaga językowa niemiecki/angielski",
      balanceSubtitle: "Pobrane bajty według modalności i języka — w źródłach startowych niemiecki nie może pozostawać za angielskim.",
      balanceEmpty: "Brak pomiarów.",
      modText: "Tekst",
      modAudio: "Dźwięk",
      modImage: "Obraz",
      modVideo: "Wideo",
      prepTitle: "Wstępne przetwarzanie",
      prepSubtitle: "Policzone etapy potoku od zarejestrowanego surowego dokumentu do przykładu treningowego — każda liczba z katalogu; błędy i elementy nieobsługiwane są nazwane.",
      prepRegistered: "zarejestrowane",
      prepScrubbed: "oczyszczone z PII",
      prepChunked: "podzielone",
      prepEmbedded: "osadzone",
      prepExtracted: "wyodrębnione",
      prepLinked: "powiązane",
      prepSamples: "przykłady",
      prepByLang: "Według języka",
      prepUnsupported: "Nieobsługiwane",
      prepAwaiting: "Czeka na etap",
      prepFailures: "Błędy",
      inboxTitle: "Skrzynka danych surowych",
      assetWhat: "Zawartość",
      assetFromSource: "ze źródła {source}",
      assetFromUpload: "wgrane ręcznie",
      mediaParquet: "Dane tabelaryczne (Parquet)",
      treeShardsHint: "Shardy to pakiety danych Parquet katalogu: każdy wiersz to pakiet z pochodzeniem, językiem i celem — kolumna „cel” mówi, co jest w folderze.",
      mediaWords: {
        text: "Tekst",
        audio: "Audio",
        video: "Wideo",
        image: "Obraz",
        application: "Plik",
      },
      inboxSubtitle: "Przekaż własne dane surowe do lake: prześlij tutaj albo umieść bezpośrednio w folderze chmurowym raw/inbox/. Uzgodnienie rejestruje każdy plik; „Przetwórz teraz” uruchamia tę samą ścieżkę, którą autopilot idzie samodzielnie.",
      uploadButton: "Prześlij plik",
      uploadHint: "Do 512 MB na plik. Przesłane trafia do zimnego magazynu, a przy przetwarzaniu jest dzielone, osadzane i wiązane w grafie wiedzy.",
      uploadTooLarge: "Plik przekracza 512 MB.",
      uploadDone: "Plik przyjęty",
      processNow: "Przetwórz teraz",
      processStarted: "Przetwarzanie uruchomione",
      reconcileNow: "Uzgodnij folder chmurowy",
      reconcileDone: "Uzgodnienie wykonane",
      unprocessedCount: "{count} nieprzetworzone",
      inboxEmpty: "Skrzynka jest pusta.",
      assetName: "Plik",
      assetType: "Typ",
      assetSize: "Rozmiar",
      assetState: "Stan",
      assetLang: "Język",
      assetRegistered: "Zarejestrowano",
      assetStates: {
        raw_stored: "surowe dane zapisane",
        awaiting_stt: "czeka na rozpoznawanie mowy",
        awaiting_content_fetch: "czeka na treść spod adresu",
        awaiting_image_codec: "czeka na kodek obrazu",
        awaiting_audio_codec: "czeka na kodek audio",
        awaiting_video_codec: "czeka na kodek wideo",
        chunked: "podzielone i w grafie",
        processed: "przetworzony",
        registered: "zarejestrowany",
        queued: "oczekuje",
        processing: "w przetwarzaniu",
        ingested: "przyjęty",
        linked: "powiązany",
        unsupported: "nieobsługiwany",
        failed: "nieudany",
      },
      graphTitle: "Graf wiedzy",
      graphSubtitle: "Powiązany korpus surowy: węzły i krawędzie policzone z katalogu — z tych powiązań powstają przykłady treningowe.",
      graphEmbedded: "Węzły z embeddingiem",
      graphModel: "Model embeddingu",
      graphClusters: "Klastry",
      graphAssetsLinked: "Powiązane dane surowe",
      graphLastLink: "Ostatnie powiązanie",
      graphNodesTitle: "Węzły według rodzaju",
      graphEdgesTitle: "Krawędzie według rodzaju",
      graphEmpty: "Graf jest jeszcze pusty — powstaje wraz z pierwszym przetworzonym plikiem.",
      kindCol: "Rodzaj",
      countCol: "Liczba",
      neighborsTitle: "Sąsiedzi węzła",
      nodeIdLabel: "ID węzła",
      neighborsRun: "Pobierz sąsiadów",
      neighborsEmpty: "Nie znaleziono sąsiadów.",
      nodeCol: "Węzeł",
      edgeKindCol: "Krawędź",
      weightCol: "Waga",
      gapTitle: "Macierz pokrycia i luk",
      gapSubtitle: "Zmierzony zasób wobec ustawionych celów mieszania według zdolności, sygnatury i poziomu — widok SQL nad katalogiem, nigdy wpisany na stałe.",
      tier: "Poziom",
      gapHave: "Jest",
      gapTarget: "Cel",
      gapWeight: "Waga",
      gapPriority: "Priorytet",
      targetsTitle: "Zdefiniuj cele mieszania",
      targetsSubtitle: "Cele niosą autora i czas; bez celów macierz uczciwie pokazuje stan pusty.",
      addTargetRow: "Dodaj wiersz",
      saveTargets: "Zapisz cele",
      targetsSaved: "Cele zapisane",
      statusCol: "Status",
      tdvTitle: "Zapieczętowana wersja danych",
      tdvSubtitle: "Wersja danych jest niezmienna i złożona z zapieczętowanych shardów; nowa zastępuje poprzednią.",
      createTdv: "Utwórz szkic TDV",
      tdvCreated: "Szkic TDV utworzony",
      tdvId: "TDV",
      tdvName: "Nazwa",
      tdvMembers: "Składniki",
      tdvCreatedAt: "Utworzona",
      tdvSealedAt: "Zapieczętowana",
      tdvStatusDraft: "szkic",
      tdvStatusSealed: "zapieczętowana",
      sealTdv: "Zapieczętuj",
      tdvSealed: "TDV zapieczętowana",
      tdvEmpty: "Nie ma jeszcze Train Data Version — powstaje ona z zapieczętowanych shardów.",
      compatTitle: "Kontrola zgodności architektury i danych",
      compatSubtitle: "Reguły R1–R12 nad dwoma dokumentami czytelnymi maszynowo; panel pokazuje zapisany raport silnika i nie oblicza własnego werdyktu.",
      compatAllGreen: "ALL-GREEN",
      compatNotGreen: "nie ALL-GREEN",
      compatRun: "Wykonaj kontrolę",
      compatChecked: "Kontrola wykonana",
      compatSelectTdv: "Wybierz TDV z listy powyżej, aby zobaczyć jej raport.",
      compatNoReport: "Dla tej TDV nie ma jeszcze zapisanego raportu zgodności.",
      compatDraftNote: "Interfejs danych architektury jest szkicem — artefakty tokenizera i kodeków jeszcze nie istnieją; kontrola uaktywni się z pierwszym wydaniem tokenizera i pierwszą zapieczętowaną TDV.",
      compatRule: "Reguła",
      compatTitleCol: "Tytuł",
      compatKind: "Rodzaj",
      compatEvidence: "Porównane wartości (dowód)",
      kindHard: "twarda",
      kindWarn: "ostrzeżenie",
      reportsTitle: "Zapisane raporty",
      reportsEmpty: "Nie zapisano jeszcze raportu zgodności.",
      phaseLabel: "Faza treningu",
      phaseA: "Faza A — gotowość i ewolucja",
      phaseB: "Faza B — trening trwa, architektura zamrożona",
      checklistTitle: "Gotowość do treningu (lista kontrolna fazy A)",
      checklistSubtitle: "Warunki liczone na żywo; start pozostaje zablokowany, dopóki każdy punkt nie jest zielony, a każdy niespełniony punkt jest nazwany.",
      checklistReady: "gotowe",
      checklistUnmet: "niespełnione punkty: {count}",
      checklistUnavailable: "Lista kontrolna jest nieosiągalna.",
      itemSatisfied: "spełniony",
      itemUnsatisfied: "niespełniony",
      startTraining: "Uruchom fazę B",
      strandTitle: 'Gałąź treningowa',
      strandSubtitle: 'Która gałąź modelu trenuje, gdy wszystkie warunki są spełnione; niewybrana gałąź nadal przygotowuje dane, ale nigdy nie startuje.',
      strandSelectedBadge: 'wybrana',
      strandExplain: 'Autopilot trenuje {selected}. {other} nadal zbiera i przygotowuje, ale nie startuje, dopóki nie zostanie wybrana.',
      strandSwitched: 'Wybór zapisany.',
      strandSwitchFailed: 'Przełączenie nie powiodło się.',
      strandUnavailable: 'Ten backend nie udostępnia jeszcze gałęzi; wybór pojawi się po następnym wdrożeniu rdzenia.',
      trainingStarted: "Faza B uruchomiona",
      startBlocked: "Start zablokowany — niespełnione: {items}",
      selectedTdvLabel: "Wybrana wersja danych",
      computedAt: "Obliczono",
      runsTitle: "Przebiegi treningowe",
      runsSubtitle: "Tylko rzeczywiste przebiegi z katalogu; nie istnieje żaden symulowany proces treningu.",
      runId: "Przebieg",
      archVersion: "Architektura",
      presetCol: "Preset",
      seqLenCol: "Długość sekwencji",
      stepCol: "Krok",
      lossCol: "Loss",
      runStarted: "Rozpoczęty",
      runFinished: "Zakończony",
      runsEmpty: "Nie ma jeszcze przebiegu treningowego.",
      abortRun: "Przerwij",
      confirmAbort: "Przerwać ten przebieg treningowy?",
      runAborted: "Zażądano przerwania",
      benchLink: "Benchmark",
      benchTitle: "Raporty benchmarków",
      benchSubtitle: "Zamrożony, wersjonowany zestaw uruchamia się automatycznie po każdym treningu; każdy raport leży w lake i jest pokazany tutaj.",
      benchEmpty: "Brak raportu benchmarku.",
      suiteVersion: "Zestaw",
      benchOpen: "Otwórz",
      benchReportFor: "Raport benchmarku dla przebiegu {run}",
      benchNoMarkdown: "Ten raport nie zawiera wyrenderowanego dokumentu; surowe wyniki poniżej.",
      exportsTitle: "Eksporty",
      exportsSubtitle: "Pobrania istnieją wyłącznie dla eksportów ukończonych rzeczywistych przebiegów treningowych.",
      exportId: "Eksport",
      exportSize: "Rozmiar",
      exportSha: "SHA-256",
      download: "Pobierz",
      exportsEmpty: "Nie ma jeszcze eksportu — powstaje on dopiero z ukończonego rzeczywistego przebiegu treningowego.",
      hfTitle: "Publikacje na HuggingFace",
      hfSubtitle: "Każdy upload jest prywatny; widoczność jest weryfikowana przez API po uploadzie. Wynik nieprywatny to stan błędu, który zatrzymuje cykl.",
      hfEmpty: "Brak publikacji.",
      hfRepo: "Repozytorium",
      hfState: "Stan",
      hfVisibility: "Widoczność",
      hfPrivateVerified: "prywatne — zweryfikowano",
      hfUnverified: "jeszcze nie zweryfikowano",
      hfVerifiedAt: "Zweryfikowano",
      connectTitle: "Połącz Block Storage",
      connectSubtitle: "Logowanie w oknie logowania dostawcy magazynu; magazyn łączy się z kontem, które potwierdzi.",
      webConnectStart: "Połącz z dostawcą magazynu",
      webConnectWaiting: "Oczekiwanie na potwierdzenie w oknie logowania dostawcy magazynu…",
      webConnectHint: "Po potwierdzeniu magazyn połączy się automatycznie; okno odświeży się samo.",
      publicIdentity: "Publiczna tożsamość aplikacji (rclone, współdzielony limit)",
      publicIdentityNote: "Okno logowania dostawcy magazynu pokazuje „rclone” jako aplikację proszącą o dostęp — to publicznie współdzielona tożsamość; własny client ID (GDRIVE_OAUTH_CLIENT_ID) zastępuje ją w każdej chwili.",
      manualHint: "Po potwierdzeniu przeglądarka pokaże nieosiągalną stronę localhost. Skopiuj wartość parametru code= z paska adresu i wklej ją tutaj (wklejenie całego adresu też działa).",
      manualCodeLabel: "Kod autoryzacji",
      manualSubmit: "Wykorzystaj kod",
      deviceInstead: "Użyj zamiast tego kodu urządzenia",
      licenseAcceptLink: "Potwierdź licencję w Hugging Face",
      deviceFlowTitle: "Połącz Block Storage (device flow)",
      deviceFlowSubtitle: "Silnik uruchamia przepływ logowania dostawcy dla urządzeń; potwierdzenie następuje na drugim urządzeniu i jest odpytywane w ograniczonych odstępach.",
      deviceFlowStart: "Uruchom przepływ logowania",
      deviceFlowCode: "Kod urządzenia",
      deviceFlowOpenUrl: "Otwórz stronę potwierdzenia",
      deviceFlowWaiting: "Oczekiwanie na potwierdzenie — odpytywanie w odstępie zaleconym przez dostawcę.",
      deviceFlowAuthorized: "Połączono",
      deviceFlowExpired: "Kod urządzenia wygasł — uruchom przepływ logowania ponownie.",
      readinessTitle: "Gotowość do treningu",
      readinessSubtitle: "Zmierzona droga do pierwszego treningu, etap po etapie.",
      readinessCounter: "{green} z {total} spełnionych",
      readinessReady: "Gotowe do treningu",
      unblockLabel: "Następny krok",
      readinessUnavailable: "Przegląd gotowości nie został jeszcze wdrożony w backendzie. Gdy tylko endpoint będzie dostępny, pojawi się tu zmierzony stan.",
      stageStates: {
        ok: "spełniony",
        active: "w toku",
        waiting: "oczekuje",
        blocked: "zablokowany",
      },
    },
    gt: {
      loading: '…',
      unavailable: 'niedostępne',
      equilibrium: 'Osiągnięto optymalny stan operacyjny: wszystkie zapytania uzyskały odpowiedź, wszystkie przekazania zadań zostały przetworzone, a redundancje wyeliminowane.',
      standby: 'czuwanie',
      defTitle: 'Operacyjna Koordynacja Zespołu i Metryki Wydajności',
      defSubtitle: 'Pomiar operacyjnej jakości komunikacji i przekazywania zadań wszystkich ról AI: nacisk na zweryfikowane rezultaty zamiast nieproduktywnej aktywności.',
      defPlayers: 'Zaangażowane Role i Systemy',
      defPlayersText: 'Dziesięć wyspecjalizowanych ról AI z botami Webex oraz ludzcy decydenci wyznaczający zadania i wytyczne.',
      defStrategies: 'Zasady Komunikacji i Pracy',
      defStrategiesText: 'Bezpośrednie odpowiadanie na pytania, jednoznaczne i kompletne przekazywanie zadań, unikanie powtórzeń oraz konsekwentne domykanie otwartych pakietów prac.',
      defPayoff: 'Wkład Operacyjny Netto (Użyteczność Netto)',
      defPayoffText: 'Ukończone pakiety prac, pomyślnie przetworzone przekazania i udzielone odpowiedzi — pomniejszone o straty tarcia (powtórzenia, nieprzetworzone przekazania, pytania bez odpowiedzi).',
      defEquilibrium: 'Optymalny Stan Operacyjny (Równowaga Koordynacyjna)',
      defEquilibriumText: 'Docelowy stan współpracy: każde zapytanie otrzymuje terminową odpowiedź, każde przekazanie zadania zostaje podjęte, żadna informacja nie jest dublowana i żaden pakiet prac nie utknie.',
      playersTitle: 'Przegląd Wydajności według Ról (Stanowiska)',
      playersSubtitle: 'Operacyjne wskaźniki komunikacji i dostarczania według ról: wkłady merytoryczne i przekazania (ostatnie 7 dni) oraz spotkania i ukończone pakiety prac (ostatnie 30 dni).',
      playersHint: 'Użyteczność netto = 3 × ukończone pakiety prac + przetworzone przekazania − straty tarcia (nieprzetworzone przekazania liczą się podwójnie). Wartość ujemna wskazuje na potrzebę koordynacji.',
      player: 'Rola / Stanowisko',
      contributions: 'Wpisy',
      meetingTurns: 'Spotkania',
      handovers: 'Przekazania',
      consumedShort: 'przetworzone',
      refusedShort: 'odrzucone',
      delivery: 'Doręczenie',
      pausedTurns: 'Wstrzymane tury',
      pausedTurnsHint: 'Tury zapisane w skrzynce samego współpracownika, ponieważ modele nie mogły ich wtedy obsłużyć. To nie są przekazania.',
      closedOpen: 'zamknięte / otwarte',
      noise: 'Strata tarcia',
      utility: 'Wkład netto',
      meetingsLine: '{held} spotkań, {turns} wypowiedzi, {u} wywołań bez odpowiedzi (30 dni).',
      interactionsTitle: 'Przekazania Zadań między Rolami (Macierz Handover)',
      interactionsSubtitle: 'Skierowane przekazania zadań między skrzynkami (ostatnie 7 dni): liczba, czas dostarczenia oraz przekazania przetworzone i odrzucone.',
      interactionsHint: 'Przekazanie zadania uznaje się za zakończone dopiero po przetworzeniu przez odbiorcę; odrzucone lub nieprzetworzone przekazania są oznaczane jako odchylenia procesowe.',
      interactionsEmpty: 'Brak przekazań w tym oknie.',
      from: 'Od',
      to: 'Do',
      messages: 'Wiadomości',
      consumed: 'przetworzone',
      refused: 'odrzucone',
      deviationsTitle: 'Odchylenia Procesowe i Aktywne Wąskie Gardła',
      deviationsSubtitle: 'Bieżące luki koordynacyjne: pytania bez odpowiedzi, nieprzetworzone przekazania zadań, powtarzające się wypowiedzi lub zablokowane pakiety prac.',
      dev_unanswered_question: 'Pytanie bez odpowiedzi (przekroczony limit czasu)',
      dev_dead_air: 'Przekazanie zadania bez informacji zwrotnej',
      dev_repetition: 'Powtórzenie na spotkaniu',
      dev_meeting_unanswered: 'Bezpośrednie zapytanie bez odpowiedzi',
      dev_work_blocked: 'Praca zablokowana',
      dev_handover_hop_budget_reached: 'Osiągnięto limit przeskoków przekazania',
      dev_commitment_unkept: 'Niedotrzymana deklaracja sprintu',
      devWithheld: 'wstrzymane',
      devRepetition: 'powtórzenie',
      devDeadAir: 'nieprzetworzone przekazanie',
      devMeetingUnanswered: 'bez odpowiedzi',
      effectiveThresholdCol: 'Próg',
      excessHopsLabel: 'nadmiarowe przeskoki',
      timeTitle: 'Czasy Cyklu i Porównanie Produktywności (AI vs. praca ręczna)',
      timeSubtitle: 'Zmierzony czas realizacji ukończonych zadań programistycznych przez AI w porównaniu z szacowanym nakładem pracy ręcznej.',
      timeHint: 'Kalkulacyjne wartości referencyjne do szacowania pracochłonności; konfigurowalne przez zarząd.',
      avgCycle: 'Śr. cykl AI',
      fromTasks: 'z {n} zadań',
      speedup: 'Przyspieszenie',
      speedupHint: 'przyjęto {h} godzin ludzkiej pracy na sztukę',
      humanDelivered: 'Dostarczone osobodni',
      humanDays: 'osobodni',
      forecast: 'Prognoza otwartej pracy: {d} osobodni',
      sizes: 'Rozmiary',
      sizeSmall: 'małe',
      sizeMedium: 'średnie',
      sizeLarge: 'duże',
      scrumTitle: 'Scrum',
      scrumSubtitle: 'Sprint, story pointy i velocity, z własnych danych firmy',
      sprintLabel: 'Sprint {n}',
      ends: 'kończy się',
      committedPts: 'Zadeklarowane punkty',
      deliveredPts: 'Dostarczone punkty',
      remainingPts: 'Pozostałe punkty',
      burndownTitle: 'Burndown (pozostałe punkty na dzień)',
      velocityTitle: 'Velocity zamkniętych sprintów',
      predictability: 'przewidywalność',
      forecastLine: 'Krocząca velocity {v} punktów na sprint · backlog {b} punktów ≈ {s} sprintów',
      noSprint: 'Żaden sprint nie trwa; następne planowanie otworzy nowy.',
      noItems: 'Nic jeszcze nie zadeklarowano; sprint bierze to, co przynoszą ludzie.',
      colItem: 'Pozycja',
      colOwner: 'Odpowiedzialny',
      colPoints: 'Punkty',
      colState: 'Stan',
      itemDone: 'dostarczone',
      itemOpen: 'otwarte',
      unestimated: 'nieoszacowane',
      addedBy: 'dodane przez {who}',
      setGoal: 'Cel sprintu',
      sprintDaysLabel: 'Długość sprintu (dni)',
      save: 'Zapisz',
      endSprint: 'Zakończ sprint teraz',
      confirmEndSprint: 'Zakończyć sprint teraz? Przegląd, retrospektywa i następne planowanie odbędą się od razu.',
      planNow: 'Przeprowadź pierwsze planowanie teraz',
      confirmPlanNow: 'Przeprowadzić planowanie sprintu teraz? Otworzy pierwszy sprint w pAIoneer-scrum.',
      sprintPointsCol: 'Punkty sprintu',
      ceremonySpaceLabel: 'Przestrzeń ceremonii',
      scrumOfScrums: 'Przeprowadź Scrum of Scrums teraz',
      confirmScrumOfScrums: 'Przeprowadzić Scrum of Scrums w pAIoneer-scrum teraz?',
      lastScrumOfScrumsTitle: 'Ostatni Scrum of Scrums',
      escalatedImpedimentsTitle: 'Eskalowane przeszkody (międzyzespołowe)',
      unitBreakdownTitle: 'Podział według jednostek',
      colUnit: 'Jednostka',
      colWip: 'Praca w toku',
      colImpediments: 'Przeszkody',
    },
    nav: {
      groups: {
        gametheory: 'Koordynacja zespołu i Scrum',
        demos: 'Podglądy na żywo',
        sovereign: 'Suwerenny LLM',
        today: 'Przegląd dnia i Centrum sterowania',
        organisation: 'Organizacja',
        work: 'Praca',
        communication: 'Komunikacja',
        memory: 'Pamięć',
        platform: 'Platforma',
        products: 'Produkty',
        identity: 'Tożsamość',
      },
      pages: {
        gametheory: 'Koordynacja zespołu i Scrum',
        demos: 'Podglądy na żywo',
        llm: 'Architektura LLM — artykuł',
        training: 'Data Lake i Trening modeli AI',
        today: 'Przegląd dnia i Centrum sterowania',
        work: 'Pakiety pracy i projekty',
        coding: 'Zadania programistyczne',
        gitlab: 'GitLab i Budowanie obrazów',
        agents: 'Agenci i projekty agentów',
        research: 'Badania',
        webex: 'Przestrzenie Webex',
        mailboxes: 'Skrzynki',
        conversations: 'Rozmowy i połączenia',
        meetings: 'Spotkania',
        engines: 'Silniki AI i GPU',
        usage: 'Zużycie i budżety',
        workloads: 'Usługi kontenerowe',
        orchestrator: 'Orkiestrator MCP Veridion',
      },
      sections: {
        demos: {
          previews: 'Podglądy na żywo',
        },
        llm: {
          paper: 'Artykuł',
          monitoring: 'Monitorowanie',
        },
        training: {
          autopilot: "Autopilot",
          storage: "Chmura i drzewo folderów",
          acquisition: "Pozyskiwanie i wstępne przetwarzanie",
          data: "Dane i graf wiedzy",
          training: "Trening i publikacja",
        },
        platform: {
          nodes: 'Węzły klastra',
          events: 'Zdarzenia',
        },
        smtm: {
          runtime: 'Sterowanie środowiskiem uruchomieniowym',
          prediction: 'Sterowanie prognozami',
          status: 'Stan danych',
          reporting: 'Sygnały',
          training: 'Modele',
          console: 'Konsola trenowania',
        },
        agentic: {
          overview: 'Przegląd',
          tools: 'Narzędzia',
          mcp: 'Serwery MCP',
          activity: 'Aktywność',
        },
        'company-memory': {
          content: 'Zawartość',
          search: 'Wyszukiwanie i raporty sytuacyjne',
          facts: 'Fakty',
          entity: 'Encje',
          remember: 'Zapisz',
          audit: 'Dziennik audytu',
          console: 'Konsola zapytań',
          stores: 'Magazyny',
          graph: 'Graf wiedzy',
          day: 'Dzień',
            bubbles: 'Domeny wiedzy działów i Badania'
        },
        organisation: {
          chart: 'Schemat organizacyjny',
          colleagues: 'Koledzy AI i skrzynki',
          voices: 'Głosy',
          people: 'Osoby i przestrzenie',
          approvals: 'Zatwierdzenia i harmonogramy',
          edit: 'Edycja organizacji',
        },
        work: {
          items: 'Pakiety pracy',
          projects: 'Projekty w rozwoju',
        },
        gitlab: {
          gitlab: 'GitLab',
          builds: 'Budowanie obrazów',
        },
        agents: {
          agents: 'Agenci',
          designs: 'Projekty agentów',
          definitions: 'Definicje',
        },
        usage: {
          identities: 'Według tożsamości',
          budgets: 'Budżety tokenów',
          company: 'Instancja firmy',
          smtm: 'Veridion SMTM',
        },
        orchestrator: {
          runtime: 'Środowisko uruchomieniowe',
          mcp: 'Serwery MCP',
          tools: 'Narzędzia',
          activity: 'Aktywność',
        },
      },
      attentionTitle: 'Wymaga działania',
      attentionSubtitle: 'Stany ze wszystkich obszarów, które wymagają interwencji. Kliknięcie otwiera sekcję.',
      attentionNone: 'Nic nie wymaga działania.',
      stateTitle: 'Stan działania',
      none: 'brak',
      readyOf: '{ready} z {total} gotowych',
      connectedOf: '{connected} z {total} połączonych',
      registeredOf: '{registered} z {total} zarejestrowanych',
      showMore: 'Pokaż więcej',
      shownOf: '{shown} z {total}',
      expand: 'Rozwiń',
      collapse: 'Zwiń',
      service: 'Usługa',
      serviceLinks: 'Linki',
      controlsTitle: 'Sterowanie Veridion Core',
      confirmRemove: 'Usunąć {what}?',
      companyIdentitiesTitle: 'Tożsamości bramy instancji firmy',
      companyIdentitiesSubtitle: 'Tokeny orkiestratora i Veridion Core w bieżącym oknie bramy, każda tożsamość ze swoim budżetem.',
      conversationsTitle: 'Rozmowy z panelu',
      conversationsSubtitle: 'Dla każdego kolegi AI pisemne rozmowy z panelu; pisanie i dzwonienie otwierają okno dialogowe nad stroną.',
      conversationCount: 'Wiadomości',
      conversationLastWritten: 'Ostatnio napisano',
      conversationLastAnswered: 'Ostatnio odpowiedziano',
      exchangesTitle: 'Wiadomości i odpowiedzi',
      exchangesSubtitle: 'Każda wiadomość z panelu z odpowiedzią kolegi AI, najnowsze najpierw.',
      conversationMessage: 'Wiadomość',
      conversationAnswer: 'Odpowiedź',
      today: {
        wordTitle: 'Obowiązująca dyrektywa zarządcza',
        wordNone: 'Obecnie nie ma otwartej dyrektywy zarządczej.',
        sinceTitle: 'Zdarzenia od ostatniej wizyty',
        sinceState: 'od {time}',
        workTitle: 'Aktywne zadania i Odpowiedzialności',
        workNone: 'Żaden pakiet pracy nie jest w toku.',
        nextMeeting: 'Następne spotkanie',
        lastMeeting: 'Ostatnie spotkanie',
      },
      work: {
        title: 'Pakiety pracy',
        subtitle: 'Każdy otwarty pakiet pracy z pamięci firmy z odpowiedzialnym, stanem, priorytetem, terminem i wynikami jego scenariuszy; tytuł otwiera go w grafie.',
        item: 'Pakiet pracy',
        kind: 'Rodzaj',
        owner: 'Odpowiedzialny',
        status: 'Stan',
        priority: 'Priorytet',
        due: 'Termin',
        scenarios: 'Scenariusze',
        updated: 'Zaktualizowano',
        none: 'Brak otwartych pakietów pracy.',
        all: 'Wszyscy odpowiedzialni',
      },
      meetings: {
        subtitle: 'Spotkania kolegów AI zapisane przez Veridion Core: przedział czasu, podsumowanie i zobowiązania, które stały się pracą.',
        slot: 'Przedział',
        kind: 'Rodzaj',
        started: 'Rozpoczęto',
        ended: 'Zakończono',
        summary: 'Podsumowanie',
        commitments: 'Zobowiązania',
        hold: 'Zwołaj spotkanie teraz',
        held: 'Spotkanie zostało zwołane.',
        notHeld: 'Spotkanie trwa lub odbyło się w ciągu ostatniego półgodziny.',
        holdFailed: 'Nie udało się zwołać spotkania',
        none: 'Nie zapisano jeszcze żadnego spotkania.',
      },
      research: {
        title: 'Badania',
        subtitle: 'Badania kolegów AI z osi czasu firmy, najnowsze najpierw.',
      },
      attention: {
        toneError: 'Awaria',
        toneWarning: 'Uwaga',
        state: {
          platform: '{ready} z {workloads} workloadów gotowych, {nodes} z {total} węzłów gotowych, {restarts} restartów.',
          gateway: '{state}; {models} modeli routowanych, {backends} z {total} backendów serwujących gotowych.',
          engine: '{engine}: {running} w toku, {waiting} oczekujących',
          usage: '{tokens} tokenów w {identities} tożsamościach w oknie {window}.',
          smtm: 'Bramka prognoz {gate}, przebudowa {rebuild}; {online} z {models} modeli online, {failed} nieudanych.',
          smtmSignals: '{open} otwartych sygnałów, {resolved} rozstrzygniętych, {failed} dostaw nieudanych.',
          smtmVeridion: '{connected} z {servers} serwerów MCP połączonych.',
          company: 'Orkiestrator {status}; {ready} z {workloads} workloadów gotowych; Veridion Core {core}; {agents} agentów działa, {waiting} oczekuje.',
          companyWebex: '{registered} z {bots} webhooków botów zarejestrowanych.',
          approvals: '{approvals} otwartych zatwierdzeń; {tasks} zadań kodowania czeka na osobę lub przegląd.',
          sessions: '{users} zalogowanych użytkowników, {sessions} sesji, {mfa} zweryfikowanych, {total} kont.',
          mail: 'SMTP {state}.',
        },
        platformUnreadable: 'Nie można odczytać stanu platformy.',
        nodeNotReady: 'Węzeł {name} nie jest gotowy.',
        nodePressure: 'Węzeł {name} zgłasza niedobór: {pressure}.',
        workloadDown: '{name} ({namespace}): gotowe {ready} z {desired}.',
        gatewayNotProgrammed: 'Bramka AI nie jest zaprogramowana.',
        smtmGateClosed: 'Bramka prognoz jest zamknięta.',
        smtmRebuild: 'Oznaczono przebudowę.',
        smtmHint: 'Stan danych: {hint}.',
        smtmDeliveryFailed: 'Nieudane doręczenia sygnałów: {count}.',
        smtmModelsFailed: 'Modele zgłaszające błąd: {count}.',
        mcpUnreachable: 'Serwer MCP {server} instancji {instance} jest nieosiągalny.',
        partUnavailable: 'Veridion pAIoneer Labs GmbH: {part} nie odpowiada.',
        parts: {
          orchestrator: 'orkiestrator',
          webex: 'most Webex',
          knowledge: 'baza wiedzy',
          core: 'Veridion Core',
          mcp: 'serwery MCP',
          usage: 'rejestr zużycia',
          gateway: 'zużycie bramki',
        },
        emergencyStop: 'Zatrzymanie awaryjne Veridion Core jest włączone.',
        coreMisconfigured: 'W Veridion Core brakuje ustawień: {missing}.',
        agentsWaiting: 'Agenci czekający na odpowiedź: {count}.',
        hostedNotRunning: '{agent} nie działa.',
        webhookMissing: 'Webhook bota {bot} nie jest zarejestrowany.',
        readerNotAuthorised: 'Odczyt przestrzeni firmy nie jest autoryzowany.',
        approvalOpen: 'Otwarte zatwierdzenie ({position}): {question}',
        taskWaiting: 'Zadanie programistyczne czeka na osobę: {title}',
        taskReview: 'Merge request gotowy do przeglądu: {title}',
      },
    },
    ops: {
      showDetails: 'Szczegóły',
      hideDetails: 'Zamknij',
      mcpVersion: 'Wersja',
      mcpUrl: 'Adres',
      mcpProtocol: 'Transport i protokół',
      mcpLastRefresh: 'Ostatnie zapytanie',
      mcpError: 'Błąd',
      noTools: 'Brak zgłoszonych narzędzi.',
      toolServer: 'Pochodzenie',
      toolAccess: 'Dostęp',
      toolBuiltIn: 'Veridion',
      accessReadOnly: 'odczyt',
      accessWrites: 'zapis',
      accessDestructive: 'zmienia dane',
      accessUndeclared: 'nie zadeklarowano',
      usageTitle: 'Zużycie',
      smtmUsageSubtitle: 'Wywołania modeli, tokeny i koszty zgłoszone przez dostawcę z ostatnich 30 dni.',
      usageByPerson: 'Według osoby',
      usageByModel: 'Według modelu',
      usageByDay: 'Według dnia',
      model: 'Model',
      day: 'Dzień',
      promptTokens: 'Tokeny wejściowe',
      completionTokens: 'Tokeny wyjściowe',
      noUsage: 'Brak zaksięgowanego zużycia.',
      runtimeTitle: 'Środowisko uruchomieniowe',
      runtimeSubtitle: 'Jak orkiestrator tej instancji odwołuje się do modeli i podłącza narzędzia.',
      executionMode: 'Wykonanie',
      providerProtocol: 'Protokół do modelu',
      contextWindow: 'Okno kontekstu',
      requestTimeout: 'Limit czasu żądania',
      diagnostics: 'Diagnostyka',
      diagnosticsOn: 'włączona',
      diagnosticsOff: 'wyłączona (tryb wydajności)',
      externalServers: 'Połączone serwery MCP',
      mcpEndpoint: 'Punkt końcowy MCP',
      workloadsTitle: 'Obciążenia',
      workloadsSubtitle: 'Obciążenia w przestrzeni nazw paioneer-veridion w ujęciu Kubernetes.',
      botsTitle: 'Boty',
      botsSubtitle: 'Boty organizacji, każdy z własnym webhookiem, oraz usługi mostu.',
      botAddress: 'Adres',
      cardWebhook: 'Webhook kart',
      webhookState: 'Stan',
      noBots: 'Most nie zgłasza botów.',
      bridgeServices: {
        knowledgeBase: 'Baza wiedzy',
        webResearch: 'Wyszukiwanie w internecie',
        osint: 'OSINT',
        anonymizer: 'Anonimizacja',
      },
      connected: 'podłączone',
      notConnected: 'niepodłączone',
      activeRooms: 'Aktywne pokoje',
      allowedRooms: 'Dozwolone pokoje',
      surface: 'Powierzchnia',
      missingSettings: 'Brakujące ustawienia',
      none: 'brak',
      instanceToolsTitle: 'Narzędzia orkiestratora',
      instanceToolsSubtitle: 'Narzędzia zarejestrowane przez orkiestrator instancji firmowej.',
      openMailbox: 'Skrzynka',
      positionMailboxHint: 'Współpracownicy AI obsługują przekazania od innych współpracowników AI; zlecenie dla współpracownika AI składa się w jego przestrzeni Webex.',
      mailboxesTitle: 'Skrzynki',
      mailboxesSubtitle: 'Dla każdego agenta: co czeka w jego skrzynce, co doręczono i co przeczytano. Kliknięcie wiersza filtruje wiadomości.',
      readAt: 'Odczytano',
      refresh: 'Odśwież',
      mailbox: 'Skrzynka',
      mailboxKind: 'Rodzaj',
      mailboxKinds: {
        position: 'Współpracownik AI',
        hosted: 'Agent hostowany',
        graph: 'Agent',
      },
      lastMessage: 'Ostatnia wiadomość',
      noMailboxes: 'Nie można odczytać żadnej skrzynki.',
      messagesTitle: 'Wiadomości',
      messagesSubtitle: 'Wiadomości, polecenia i przekazania, od najnowszych. Kliknięcie pokazuje pełny tekst.',
      allMailboxes: 'Wszystkie skrzynki',
      allStates: 'Wszystkie stany',
      time: 'Czas',
      from: 'Od',
      to: 'Do',
      messageKind: 'Rodzaj',
      content: 'Treść',
      reply: 'Odpowiedź',
      noMessages: 'Brak wiadomości.',
      messageKinds: {
        message: 'Wiadomość',
        handover: 'Przekazanie',
        command: 'Polecenie',
        resume: 'Wznowienie',
        subagent_result: 'Wynik subagenta',
        review: 'Przegląd',
      },
      buildsTitle: 'Kompilacje',
      buildsSubtitle: 'Obrazy zbudowane przez Veridion Core dla agentów, od najnowszych.',
      image: 'Obraz',
      started: 'Rozpoczęto',
      finished: 'Zakończono',
      noBuilds: 'Brak kompilacji.',
      coreToolsTitle: 'Narzędzia agentów',
      coreToolsSubtitle: 'Narzędzia orkiestratora, które Veridion Core udostępnia swoim agentom.',
      description: 'Opis',
      coreDailyTitle: 'Zużycie według dnia i modelu',
      coreDailySubtitle: 'Wywołania modeli przez Veridion Core z ostatnich 30 dni, według agenta i modelu.',
      coreActivityTitle: 'Aktywność Veridion Core',
      coreActivitySubtitle: 'Zdarzenia agentów, współpracowników AI i przekazań w Veridion Core, od najnowszych.',
      event: 'Zdarzenie',
      tool: 'Narzędzie',
      detail: 'Szczegół',
    },
    tabCompanyMemory: 'Pamięć firmy',
    llmPaper: {
      subtitle: 'Wygenerowany naukowy opis suwerennej architektury modelu — renderowany z dokumentu w stylu artykułu, który Veridion Core prowadzi dla aktywnej specyfikacji.',
      summaryTitle: 'Co pokazuje ta strona',
      summaryBody: 'Veridion Core prowadzi dla aktywnej architektury modelu wygenerowany dokument naukowy: tytuł, streszczenie, numerowane sekcje, diagram architektury, tabele i bibliografia przychodzą z backendu bez zmian; wartości projektowe są oznaczone jako takie, a strona niczego nie wymyśla.',
      refresh: 'Odśwież',
      exportPdf: 'Eksportuj jako PDF',
      strandTraining: 'trenowany',
      strandSelected: 'wybrana',
      lcTitle: "Implementacja i cykl życia",
      lcSelectedTrains: "trenuje jako następny",
      lcCollectsOnly: "zbiera i przygotowuje — nie startuje",
      lcSpec: "Specyfikacja",
      lcFrozen: "zamrożona",
      lcArtifacts: "Artefakty (tokenizer/kodek)",
      lcReleased: "wydane",
      lcNotReleased: "jeszcze nie zbudowane",
      lcCodecOpen: "kodek otwarty",
      lcData: "Progi danych",
      lcThresholdsMet: "spełnione",
      lcAreasReached: "plan danych: osiągnięto {met} z {total} dziedzin",
      lcNoLake: "jezioro danych niedostępne",
      lcStage_trainer_image: "Obraz trenera",
      lcStage_sealed_tdv: "TDV zapieczętowana",
      lcStage_compat_all_green: "Zgodność ALL-GREEN",
      lcStage_vram_budget: "Budżet VRAM",
      lcTraining: "Trening",
      lcAuto: "startuje automatycznie po spełnieniu progów",
      lcBench: "Benchmark",
      lcBenchRows: "pomiarów",
      lcNoneYet: "jeszcze brak",
      lcRelease: "Eksport · Hugging Face (prywatne) · rejestr",
      lcReleaseRows: "artefaktów",
      lcReleaseNote: "po treningu: zweryfikowany prywatny upload + wpis do rejestru",
      lcPipeline: "Potok treningowy",
      lcDone: "gotowe",
      lcActive: "aktywne",
      lcWaiting: "oczekuje",
      lcBlocked: "zablokowane",
      lcCapability: "Zdolność",
      lcSamples: "Próbki",
      lcByLanguage: "wg języka",
      lcForeign: 'inny nurt',
      lcCorpus: 'Tokeny korpusu',
      lcCorpusNone: 'jeszcze nie ztokenizowano',
      loading: 'Ładowanie …',
      unavailable: 'Dokument jest niedostępny.',
      noPaper: 'Ta wersja Veridion Core nie udostępnia jeszcze dokumentu w stylu artykułu. Strona nie pokazuje więc niczego wymyślonego.',
      abstract: 'Streszczenie',
      references: 'Bibliografia',
      appendix: 'Dodatek',
      figure: 'Rysunek',
      lastUpdated: 'Ostatnia aktualizacja',
      empty: 'Brak wpisów.',
    },
    llmMonitor: {
      summary: "Nadzór eksploatacyjny modelu: stan, dane, GPU, jądra i przepustowość, ewaluacje i zdarzenia — zmierzone z Veridion Core i data lake, nic zmyślonego.",
      archTitle: 'Status architektury',
      archSubtitle: "Aktywna architektura ze stanem interfejsu danych i stanem zamrożenia.",
      version: 'Wersja',
      codename: 'Kryptonim',
      statusLabel: 'Status',
      interfaceStatus: 'Interfejs danych',
      specSha: 'Hash specyfikacji (SHA-256, skrócony)',
      promotedAt: 'Awansowana',
      frozenLabel: 'Zamrożona',
      frozenYes: 'Tak',
      frozenNo: 'Nie',
      stateWord_active: "aktywna",
      stateWord_draft: "szkic",
      stateWord_released: "wydana",
      stateWord_candidate: "kandydat",
      stateWord_retired: "zakończona",
      gpuModel: "Karta graficzna",
      gpuTotal: "Łączna pamięć graficzna",
      gpuWindow: "Okno treningowe (zmierzone)",
      gpuMeasuredAt: "Zmierzono",
      gpuSource: "Źródło pomiaru",
      gpuServing: "Serwowanie",
      gpuInferenceTarget: "Cel inferencji na jednej karcie",
      vramTitle: 'GPU i budżet VRAM',
      vramSubtitle: 'Zmierzony budżet VRAM karty graficznej, tak jak prowadzi go Veridion Core.',
      vramNone: 'Brak budżetu VRAM w rekordzie.',
      gateTitle: 'Bramka promocji',
      gateSubtitle: 'Zasada, według której architektura kandydująca zastępuje aktywną, z wymaganymi metrykami i ich wagami.',
      metric: 'Metryka',
      weight: 'Waga',
      gateNone: 'Brak zarejestrowanych wymaganych metryk.',
      candidatesTitle: 'Kandydatki',
      candidatesNone: 'Brak architektur kandydujących.',
      evidenceTitle: 'Ewaluacje',
      evidenceNone: 'Brak zmierzonych ewaluacji.',
      benchmark: 'Benchmark',
      suite: 'Zestaw',
      score: 'Wynik',
      evaluator: 'Oceniający',
      date: 'Data',
      changelogTitle: 'Historia zmian',
      changelogNone: 'W historii nie ma jeszcze wersji architektury.',
      summaryLabel: 'Podsumowanie',
      createdAt: 'Utworzona',
      supersededAt: 'Zastąpiona',
      eventsTitle: 'Zdarzenia',
      eventsNone: 'Brak zarejestrowanych zdarzeń.',
      implTitle: 'Stan implementacji gałęzi',
      implSubtitle: "Zmierzone fakty: artefakty interfejsu danych, wybór, korpus tokenów i indeks wektorowy; plan danych dla dziedzin jest w sytuacji.",
      implSelected: 'Gałąź treningowa',
      implSelectedYes: 'wybrana — trenuje jako następna',
      implSelectedNo: 'tylko przygotowuje (nigdy nie startuje)',
      implTokenizer: 'Artefakt tokenizera',
      implCodec: 'Artefakt kodeka',
      implNotReleased: 'jeszcze nieopublikowany',
      implCapability: 'Zdolność',
      implSamples: 'Przykłady (zmierzone/cel)',
      implNoDatalake: 'Postęp przykładów jest chwilowo nieczytelny (interfejs data lake niedostępny).',
      implSwitchHint: 'Wybór gałęzi treningowej zmienia się na stronie treningu.',
      implSituationLink: "Gdzie są dane i czego brakuje do treningu: sytuacja na stronie treningu",
      kernelTitle: 'Przyspieszenie jąder i przepustowość',
      kernelSubtitle: 'Co sonda jąder zmierzyła na karcie: każde jądro względem swojego odniesienia, backend uwagi, przepustowość wybranej specyfikacji — oraz plan czasowy obliczony ze zmierzonych tokenów i zmierzonej przepustowości.',
      kernelNone: 'Na tej karcie nie uruchomiono jeszcze sondy jąder; niczego się nie zakłada.',
      kernelName: 'Jądro',
      kernelVerified: 'Udowodnione',
      kernelYes: 'tak',
      kernelNo: 'nie',
      kernelSpeedup: 'Przyspieszenie',
      kernelMaxErr: 'Maks. błąd',
      kernelError: 'Ustalenie',
      kernelAttention: 'Backend uwagi',
      kernelDocMask: 'Maskowanie granic dokumentów',
      kernelThroughput: 'Zmierzona przepustowość (tokeny/s)',
      kernelMicroBatch: 'Mikropartia',
      kernelMeasuredAt: 'Zmierzono',
      kernelImage: 'Obraz trenera (digest)',
      kernelRunPath: 'Ścieżka jąder ostatniego uruchomienia',
      kernelRunNone: 'Brak jeszcze uruchomienia treningu z danymi o jądrach.',
      kernelPlanTitle: 'Plan czasowy (arytmetyka na pomiarach)',
      kernelPlanTokens: 'Masa tokenów',
      kernelPlanTokensSource: 'Źródło masy tokenów',
      kernelPlanDays: 'Prognozowane dni na jeden przebieg',
      kernelPlanNone: 'Jeszcze nie zmierzono — bez zmierzonej przepustowości lub zmierzonej masy tokenów nie wymyśla się planu czasowego.',
      kernelSourceTdv: 'zapieczętowana wersja danych treningowych',
      kernelSourceCorpus: 'dotychczasowy korpus (niezapieczętowany)',
      kernelSourcePlan: "budżet z artykułu",
      implForeign: 'należy do innego nurtu',
      implIndex: 'Indeks wektorowy (łączenie grafu)',
      implIndexNone: 'brak zgłoszonego indeksu',
      implIndexDown: 'skonfigurowany, nie odpowiada',
      implIndexPoints: 'punkty',
      implIndexBackfillDone: 'zasilanie zakończone',
      implIndexBackfillOpen: 'zasilanie trwa',
      implIndexLink: 'Indeks i deduplikacja w monitorze jeziora',
      implCorpus: 'Korpus tokenów (surowy tekst)',
    },
    software: {
      arch: {
        execTitle: "Suwerenna architektura modelu",
        execSubtitle: "Jedyna aktywna specyfikacja architektury z Veridion Core: każda liczba jest albo poparta wskazanym artefaktem pomiaru, albo oznaczona przez backend jako cel projektowy (niezmierzony).",
        openDatalake: "Otwórz Data Lake i trening modelu AI",
        unavailableArch: "Dane architektury są nieosiągalne.",
        frozen: "Zamrożona — trwa przebieg treningowy",
        notFrozen: "Dopuszczona (faza A)",
        version: "Wersja",
        codename: "Kryptonim",
        statusLabel: "Status",
        createdAt: "Utworzona",
        promotedAt: "Awansowana",
        specSha: "Skrót specyfikacji (SHA-256)",
        contextWindow: "Okno kontekstu (projekt, tokeny)",
        dataInterface: "Interfejs danych",
        diStatus: {
          draft: "szkic",
          complete: "kompletny",
          missing: "brak",
        },
        paramsTitle: "Bilans parametrów",
        trainingVramTitle: "VRAM treningu (zadeklarowany, GB)",
        inferenceTitle: "VRAM inferencji (zadeklarowany, GB)",
        declaredTotal: "Zadeklarowana suma",
        budgetTitle: "Budżet VRAM GPU (zmierzony)",
        budgetGpu: "GPU",
        budgetTotal: "Całkowity VRAM (MiB)",
        budgetFreed: "Wolny budżet treningowy (GB)",
        budgetInferenceTarget: "Cel inferencji na jednej GPU (GB)",
        diagramTitle: "Wygenerowany diagram architektury",
        diagramSubtitle: "Generowany deterministycznie z zapisanej specyfikacji; obok danych nie istnieje żaden ręcznie pisany diagram.",
        noDiagram: "Odpowiedź nie zawiera diagramu.",
        stagesTitle: "Budowa stopniowa architektury",
        stagesSubtitle: "Wprost z zapisanej specyfikacji; liczby parametrów to wartości projektowe.",
        stageCol: "Stopień",
        layersCol: "Warstwy",
        mechanismCol: "Mechanizm",
        paramsCol: "Parametry fizyczne (mld) i źródła pierwotne",
        paramsCross: "przekrojowy — policzony w stopniach",
        researchTitle: "Archiwum badań AI kwantowej i frontier",
        researchSubtitle: "Wiersze na żywo z archiwum badań Veridion Core; nowe publikacje przychodzą przez narzędzie kolegi kwantowego, każda z widocznym pochodzeniem.",
        researchEmpty: "W archiwum nie ma jeszcze publikacji.",
        evidenceTitle: "Dowody ewaluacji",
        evidenceSubtitle: "Pojawiają się tu wyłącznie zmierzone, wskazane ewaluacje; bez dowodu nie ma wyniku.",
        evalMetric: "Metryka",
        evalBenchmark: "Benchmark",
        evalSuite: "Zestaw",
        evalScore: "Wartość",
        evalEvaluator: "Oceniający",
        evalDate: "Zmierzono",
        evalArtifact: "Artefakt dowodu",
        gateTitle: "Reguły awansu (bramka dowodowa)",
        gateMetrics: "Metryki obowiązkowe",
        gateEpsilon: "Tolerancja (epsilon)",
        gateConfigVersion: "Konfiguracja bramki (wersja)",
        candidatesTitle: "Kolejka kandydatów",
        candidatesSubtitle: "Zgłoszeni kandydaci architektury ze stanem ich dowodów; zgłoszenia idą przez środowisko badawcze, nigdy przez panel.",
        candidateSubmittedBy: "Zgłoszony przez",
        candidateEvidence: "Dowody (są / wymagane)",
        candidatesEmpty: "Nie zgłoszono kandydata.",
        changelogTitle: "Dziennik zmian projektu",
        changelogSubtitle: "Zastąpione iteracje projektu — celowo bez liczb: dla nich nigdy niczego nie zmierzono.",
        changelogSummary: "Streszczenie",
        changelogEmpty: "Brak zastąpionego projektu.",
        supersededAt: "Zastąpiona",
        eventsTitle: "Zdarzenia bramki",
        eventsSubtitle: "Zgłoszenia, awanse, odrzucenia i przejścia zamrożenia tak, jak zapisała je bramka.",
        eventsEmpty: "Nie ma jeszcze zdarzeń.",
      },
      title: 'Tworzenie oprogramowania',
      subtitle: 'Zadania agenta programującego, GitLab firmy z synchronizacją z Azure DevOps, merge requesty czekające na przegląd i limity węzła GitLab.',
      openGitlab: 'Otwórz GitLab',
      openSonar: 'Otwórz SonarQube',
      loading: 'Ładowanie …',
      failed: 'Nie udało się',
      done: 'Gotowe',
      unavailable: 'Niedostępne',
      capacityTitle: 'Węzeł GitLab',
      capacitySubtitle: 'Strażnik co minutę ustala limity węzła na podstawie obciążenia serwera; produkcja zachowuje swoją rezerwę.',
      stateLabel: 'Stan',
      memory: 'Pamięć',
      cpu: 'CPU',
      disk: 'Dysk',
      hostFree: 'Wolne na serwerze',
      reserve: 'Rezerwa dla produkcji',
      codingSlots: 'Zadania naraz',
      pipelineQuota: 'Zadania potoku',
      recentActions: 'Ostatnie działania strażnika',
      syncTitle: 'Synchronizacja z Azure DevOps',
      syncSubtitle: 'Master w GitLabie podąża za masterem w Azure; commity, które miał tylko GitLab, zostają zachowane pod tagiem replaced/<czas>.',
      syncNow: 'Synchronizuj teraz',
      syncStarted: 'Synchronizacja uruchomiona',
      azureCommit: 'Master w Azure',
      gitlabCommit: 'Master w GitLabie',
      lastChange: 'Ostatnia zmiana',
      lastRun: 'Ostatnie uruchomienie',
      replaced: 'Zachowane pod tagami',
      noneReplaced: 'nic',
      jobs: 'Ostatnie uruchomienia',
      error: 'Błąd',
      readyTitle: 'Merge requesty gotowe do przeglądu',
      readySubtitle: 'Tylko merge requesty z zielonym potokiem; scala się je w GitLabie.',
      noReady: 'Żaden merge request nie czeka na przegląd.',
      tasksTitle: 'Zadania programistyczne',
      tasksSubtitle: 'Każda praca programistyczna agenta ze stanem, merge requestem i tokenami.',
      showFinished: 'Pokaż zakończone zadania',
      task: 'Zadanie',
      requester: 'Zlecający',
      statusLabel: 'Stan',
      mergeRequest: 'Merge request',
      pipeline: 'Potok',
      tokens: 'Tokeny',
      updated: 'Zaktualizowano',
      noTasks: 'Brak jeszcze zadań programistycznych.',
      phase: 'Krok',
      repository: 'Repozytorium',
      branch: 'Gałąź',
      openQuestion: 'Otwarte pytanie',
      result: 'Wynik',
      sendMessage: 'Napisz do zadania',
      answerQuestion: 'Odpowiedz na pytanie',
      urgent: 'Pilne: natychmiast pokieruj bieżącym krokiem',
      send: 'Wyślij',
      messageSent: 'Dostarczono do zadania',
      confirmCancel: 'Anulować to zadanie? Otwarty merge request zostanie zamknięty.',
      course: 'Przebieg sesji',
      messages: 'Wiadomości',
      events: 'Zdarzenia',
      none: 'brak',
      close: 'Zamknij',
      newTitle: 'Nowe zadanie',
      newSubtitle: 'Zleć stąd zadanie agentowi programującemu; śledź je tutaj i na jego karcie w Webex.',
      brief: 'Co ma zrobić agent?',
      issue: 'Zgłoszenie YouTrack (opcjonalnie)',
      create: 'Utwórz zadanie',
      created: 'Zadanie utworzone',
      usersTitle: 'Administratorzy w GitLabie',
      usersSubtitle: 'Każdy administrator ma użytkownika GitLab z uprawnieniami administratora; housekeeping uzgadnia ich z Keycloakiem.',
      email: 'E-mail',
      gitlabUser: 'Użytkownik GitLab',
      lastHousekeeping: 'Ostatni housekeeping',
      sonarDeleted: 'Usunięto projekty SonarQube usuniętych gałęzi',
      previewsTitle: 'Projekty w rozwoju',
      previewsSubtitle: 'Każdy projekt w rozwoju działa dokładnie raz od pierwszego merge’a: Veridion Core uruchamia najnowszy zielony stan gałęzi głównej (migration lub master) w kontenerach za logowaniem administratora, odnawia go przy każdym zielonym pipeline, a kontenery uruchamia się, zatrzymuje i restartuje tutaj. Projekt, którego pipeline nie buduje nic działającego, widnieje tu z powodem.',
      previewsSummaryTitle: 'Co pokazuje ten widok',
      previewsSummaryBody: 'Każdy projekt w rozwoju działa jako własny kontener podglądu za logowaniem administratora. Lista u góry pokazuje najnowszy działający stan każdego projektu, tabela poniżej uruchomione kontenery ze stanem, adresem i sterowaniem: otwórz, uruchom, zatrzymaj, uruchom ponownie.',
      previewProject: 'Projekt',
      previewState: 'Działający stan',
      previewSince: 'Od',
      previewAddress: 'Adres',
      previewMergedAt: 'Scalono',
      noPreviews: 'Żaden projekt nie działa.',
      reasonsLabel: 'Przyczyny blokad i Diagnostyka',
      noProjects: 'Brak projektu w rozwoju.',
      qualityCoverage: 'Pokrycie testami',
      qualityBugs: 'Błędy',
      qualitySmells: 'Code smells',
      qualityDuplication: 'Duplikacja',
      qualityHotspots: 'Otwarte hotspoty',
      qualityUnavailable: 'Brak pomiarów SonarQube',
      openPreview: 'Otwórz',
      startPreview: 'Uruchom kontenery',
      stopPreview: 'Zatrzymaj kontenery',
      previewStarted: 'Kontenery uruchomione',
      previewStopped: 'Kontenery zatrzymane',
      restartPreview: 'Zrestartuj kontenery',
      previewRestarted: 'Kontenery zrestartowane',
      previewControl: 'Kontenery',
      resultTitle: 'Wynik w GitLab',
      resultJobs: 'Zadania i artefakty',
      resultSonar: 'SonarQube',
      resultDelivered: 'Dostarczono',
      previewStatus: {
        starting: 'uruchamia się',
        running: 'działa',
        stopped: 'zatrzymany',
        failed: 'nieudany',
      },
      capacityStates: {
        ok: 'w granicach',
        tight: 'ciasno: produkcja potrzebuje miejsca',
        full: 'pełno: brak nowej pracy',
        node_down: 'węzeł nie działa',
      },
      status: {
        queued: 'czeka na wolne miejsce',
        working: 'w toku',
        waiting: 'czeka na odpowiedź',
        review: 'w przeglądzie',
        merged: 'scalone w GitLabie',
        done: 'gotowe',
        needs_person: 'potrzebny człowiek',
        rejected: 'zamknięte bez scalenia',
        paused: 'wstrzymane',
        cancelled: 'anulowane',
        failed: 'nieudane',
      },
      commands: {
        pause: 'Wstrzymaj',
        resume: 'Wznów',
        cancel: 'Anuluj',
      },
      repositoryChoice: {
        auto: 'Agent decyduje',
        company: '{project} (scala człowiek)',
        own: 'Własny projekt w {group}',
      },
      userState: {
        ok: 'uzgodniony',
        created: 'utworzony',
        unblocked: 'odblokowany',
        'made administrator': 'nadano administratora',
        blocked: 'zablokowany',
      },
    },
    org: {
      write: 'Napisz',
      call: "Zadzwoń",
      callTitle: "Rozmowa z {bot}",
      writeTitle: 'Wiadomość do {bot}',
      callConfirmEnd: 'Zakończyć połączenie?',
      callSubtitle: 'Mikrofon działa przez całą rozmowę. Bot wita swoim głosem, odpowiada krótko, dopytuje o otwarte punkty i można mu przerwać. Każde zdanie pojawia się też w Webex, w pokoju bezpośrednim z botem.',
      callRinging: "Dzwoni …",
      callConnected: "Połączono",
      callEnded: "Zakończono",
      callEndedHangup: "Rozłączyłeś się",
      callEndedClosed: "Połączenie zostało zamknięte",
      callEndedSilence: "90 sekund ciszy",
      callEndedLimit: "Osiągnięto limit 30 minut",
      callEndedError: "Błąd zakończył rozmowę",
      callHangUp: "Rozłącz",
      callLevel: "Poziom mikrofonu",
      callYou: "Ty",
      callSpeaking: "Bot mówi …",
      callThinking: 'Odpowiedź jest generowana …',
      callOvertaken: "wyprzedzona przez twoje następne pytanie, niewypowiedziana",
      callNothingHeard: "Nie usłyszano żadnych słów.",
      callMicDenied: "Przeglądarka odmówiła dostępu do mikrofonu; zezwól na niego dla tej strony i zadzwoń ponownie.",
      callNoVoice: "Głos jest teraz niedostępny; odpowiedź pozostaje jako tekst.",
      callRefused: "Rozmowa nie została przyjęta: bilet był nieważny lub wygasł; zadzwoń ponownie.",
      callFailed: "Rozmowa się nie powiodła",
      voice: "Głos",
      voiceHint: "Głos, którym mówi ten kolega: w Webex, gdy osoba prosi o usłyszenie odpowiedzi, i przez telefon. Domyślnie jest to mówca modelu audio w OpenRouter; własny, sklonowany głos z magazynu głosów mówi przez silnik głosowy platformy.",
      voiceSave: "Zapisz głos",
      voiceDefault: "domyślny",
      voiceNone: "brak głosu",
      voiceCloud: "Mówcy OpenRouter (domyślnie)",
      voiceOwn: "Własne głosy (sklonowane)",
      voiceUploadTitle: "Prześlij próbkę głosu dla tego kolegi",
      voiceUploadHint: "Audio lub wideo, najwyżej 25 MB; Core konwertuje próbkę, zachowuje do 20 sekund, słyszy jej słowa i zapisuje tylko klip referencyjny. Kolega od razu mówi tym głosem.",
      voiceUploadName: "Nazwa głosu",
      voiceUploadConsent: "Potwierdzam, że mam prawo używać tego głosu dla firmy: jest mój lub osoba wyraziła zgodę.",
      voiceUploadButton: "Prześlij próbkę",
      voiceUploadDone: "Głos zapisany",
      voiceTooLarge: "Plik jest większy niż 25 MB.",
      voicesTitle: "Głosy",
      voicesSubtitle: "Każdy głos firmy to klip referencyjny w magazynie głosów Veridion Core; silnik głosu klonuje go za każdym razem, gdy bot mówi. Dziewięciu dawnych mówców stoi w nim jako przechwycone klipy.",
      voiceSeconds: "Sekundy",
      voiceSource: "Pochodzenie",
      voiceSourcePreset: "przechwycony mówca",
      voiceSourceUpload: "przesłana próbka",
      voiceAddedBy: "Dodał",
      voiceConsentBy: "Zgodę potwierdził",
      voiceWords: "Słowa klipu",
      voiceDelete: "Usuń",
      voiceConfirmDelete: "Usunąć ten głos? Koledzy, którzy go używają, znów będą mówić swoim domyślnym głosem.",
      voiceCapture: "Przechwyć mówców silnika z presetami",
      voiceCaptureHint: "Wypowiada jedno stałe zdanie na mówcę przez silnik z presetami i zapisuje je jako klip; uruchamiane przed zmianą silnika.",
      voiceCaptured: "Przechwycono",
      voiceEnginePresets: "Silnik głosu oferuje stałych mówców; magazyn głosów nie jest używany.",
      chartTitle: "Schemat organizacyjny",
      executiveTitle: 'Poziom kierowniczy',
      unitsTitle: 'Jednostki biznesowe',
      unitLead: 'Kierownik',
      unitSupporting: 'Wspierany przez',
      unitMission: 'Misja',
      unitPrefix: 'Prefiks wątku',
      standingActive: 'aktywny',
      standingStandby: 'w gotowości',
      standbyOn: 'Przełącz w gotowość',
      standbyOff: 'Aktywuj',
      standbyHint: 'W gotowości kolega nie podejmuje żadnej tury z inicjatywy firmy i nie kosztuje tokenów; na bezpośrednią wiadomość od osoby nadal odpowiada.',
      confirmStandby: 'Przełączyć {name} w gotowość?',
      confirmActivate: 'Aktywować {name}?',
      activity: 'Aktywność',
      runtime: 'Środowisko uruchomieniowe',
      modelCloud: 'model w chmurze',
      modelGpu: 'silnik firmowy',
      callModel: 'Model telefoniczny',
      calls30: 'Rozmowy, ostatnie 30 dni',
      telemetryLine: '{model} · {prompt}+{completion} tokenów · {cost} · ucho {asr} ms · umysł {llm} ms · głos {tts} ms · razem {total} ms{deferred}',
      telemetryDeferred: ' · {count} odroczonych',
      chartSubtitle: "Koledzy AI Veridiona: agenci w Veridion Core, każdy dostępny jako własny bot Webex, według obszarów; nad nimi ludzcy decydenci, pod nimi agenci bez własnego bota i przestrzenie firmy, odczytywane na żywo z Veridion Core i Webex.",
      chartPeople: "Osoby decyzyjne",
      chartPeopleText: "Ludzcy decydenci decydują o wszystkim i działają w {space}.",
      chartAgentsTitle: "Agenci bez własnego bota: agent kodujący, orkiestrator MCP Veridiona i agenci budowani przez architekta pracują w imieniu kolegi AI i mówią przez jego bota",
      chartDesigned: "Agenci zaprojektowani z architektem",
      chartFor: "W imieniu",
      chartSystemsTitle: "Podłączone systemy",
      chartSpaceHome: "Przestrzeń macierzysta dla",
      chartSpacePurpose: "Cel",
      chartRoomsTitle: "Przestrzenie firmy w Webex",
      room: "Przestrzeń",
      roomBots: "Boty",
      positionsTitle: "Współpracownicy AI",
      positionsSubtitle: "Każdy współpracownik AI odpowiada przez własnego bota i czyta swoje przestrzenie. Jego opis jest instrukcją, według której pracuje.",
      bot: "Bot",
      position: "Funkcja",
      statusLabel: "Stan",
      tokensUsed: "Zużyte tokeny",
      tokens30: "Tokeny, ostatnie 30 dni",
      edit: "Edytuj",
      close: "Zamknij",
      description: "Opis współpracownika AI",
      save: "Zapisz",
      resetDescription: "Przywróć opis domyślny",
      interests: "Profil zainteresowań",
      interestsHint: "Jakie rodzaje punktów i tematy dotyczą tego współpracownika AI i kiedy go nie dotyczą. Współpracownik AI ocenia według niego każdą wiadomość w swoich przestrzeniach.",
      threshold: 'Próg wypowiedzi bez pytania',
      thresholdHint: 'Od 1 do 5: jak bardzo wiadomość musi dotyczyć współpracownika AI, zanim zabierze on głos niepytany. Przy 1 odzywa się już przy niskiej istotności, przy 5 tylko przy wysokiej.',
      saveProfile: "Zapisz profil",
      tools: "Narzędzia",
      decisionMakersTitle: "Osoby decyzyjne",
      decisionMakersSubtitle: "Każda z nich może udzielić każdej zgody i odpowiedzieć na każde pytanie współpracownika AI w Webex.",
      email: "Adres e-mail",
      add: "Dodaj",
      remove: "Usuń",
      confirmRemove: "Usunąć tę osobę decyzyjną?",
      readerTitle: "Czytanie przestrzeni firmy",
      readerSubtitle: "Bot widzi tylko wiadomości, w których jest wspomniany. Veridion czyta każdą wiadomość w przestrzeniach firmy dzięki autoryzacji konta, które jest członkiem wszystkich.",
      notConfigured: "Integracja nie jest skonfigurowana",
      authorised: "Autoryzowano",
      notAuthorised: "Nie autoryzowano",
      account: "Konto",
      validUntil: "Token dostępu ważny do",
      renewUntil: "Autoryzację można odnawiać do",
      authorise: "Autoryzuj czytanie",
      authoriseAgain: "Autoryzuj ponownie",
      linkOpened: "Logowanie do Webex otwarto w nowej karcie.",
      found: "znaleziono",
      notFound: "nie znaleziono",
      botsInSpace: "boty",
      transcripts: "Transkrypcje spotkań",
      yes: "tak",
      no: "nie",
      approvalsTitle: "Otwarte zgody",
      approvalsSubtitle: "Zgody i pytania, o które prosili współpracownicy AI i na które nikt jeszcze nie odpowiedział.",
      originSpace: "Przestrzeń",
      directRoom: "rozmowa bezpośrednia",
      approvalKinds: { review: "zgoda", question: "pytanie" },
      schedulesTitle: "Harmonogramy",
      schedulesSubtitle: "Powtarzalna praca zlecona w przestrzeni; trwa, dopóki ktoś jej nie zakończy.",
      createdBy: "zlecone przez",
      lastRun: "ostatnie uruchomienie",
      end: "Zakończ",
      confirmEnd: "Zakończyć ten harmonogram?",
      none: "Brak",
      loading: "Ładowanie…",
      failed: "Niepowodzenie",
      working: "W toku…",
      done: "Gotowe",
      memoryTitle: "Organizacja",
      memorySubtitle: "Ludzie i współpracownicy AI firmy z zakresem pamięci, w którym pracuje każdy współpracownik AI.",
      memoryMember: "Członek",
      area: "Obszar",
      decisionMaker: "Osoba decyzyjna",
      status: { running: "działa" },
    },
    core: {
      conversationTitle: 'Rozmowa z panelu',
      conversationHint: 'Każda wiadomość i każda odpowiedź są też wypowiadane w Webex: w wątku pracy agenta, a w przeciwnym razie w Twoim pokoju bezpośrednim z botem.',
      conversationEmpty: 'Jeszcze nie ma wiadomości z panelu.',
      writeToAgent: 'Wiadomość do tego agenta',
      answerPending: 'Odpowiedź w oczekiwaniu',
      title: 'Veridion Core',
      subtitle: 'Agentowy system operacyjny stojący za firmowym botem: jego agenci, ich wiadomości i zużycie tokenów, definicje, architekt i organizacja.',
      done: 'Gotowe.',
      failed: 'To się nie udało',
      loading: 'Ładowanie …',
      working: 'Przetwarzanie …',
      none: 'Brak.',
      unavailable: 'Veridion Core jest nieosiągalny',
      errors: {
        AGENT_FINISHED: 'Agent zakończył działanie i nie przyjmuje już wiadomości',
        EMERGENCY_STOP: 'Zatrzymanie awaryjne jest włączone',
        DEFINITION_INVALID: 'Definicja jest nieprawidłowa',
        TOO_MANY_AGENTS: 'Działa zbyt wielu agentów',
        VERIDION_CORE_NOT_CONFIGURED: 'Veridion Core nie jest skonfigurowany',
        MESSAGE_EMPTY: 'Wiadomość jest pusta',
      },
      status: {
        building: 'budowanie obrazu',
        starting: 'uruchamianie',
        running: 'działa',
        waiting: 'oczekuje',
        idle: 'bezczynny',
        paused: 'wstrzymany',
        completed: 'zakończony',
        failed: 'nieudany',
        cancelled: 'anulowany',
        stopped: 'zatrzymany',
        not_deployed: 'niewdrożony',
      },
      statusLabel: 'Status',
      owner: 'Właściciel',
      definition: 'Definicja',
      parent: 'Agent nadrzędny',
      tokens: 'Tokeny',
      progress: 'Postęp',
      close: 'Zamknij',
      openQuestion: 'Otwarte pytanie',
      result: 'Wynik',
      answerQuestion: 'Odpowiedz na pytanie',
      sendMessage: 'Wiadomość do agenta',
      urgent: 'Pilne: przerwij bieżący krok',
      send: 'Wyślij',
      messageSent: 'Dostarczono do agenta.',
      commands: {
        pause: 'Wstrzymaj',
        resume: 'Wznów',
        cancel: 'Anuluj',
        kill: 'Zakończ natychmiast',
      },
      confirmKill: 'Natychmiast zakończyć tego agenta i jego agentów podrzędnych?',
      subAgents: 'Agenci podrzędni',
      graph: 'Graf',
      messages: 'Wiadomości',
      messageStatus: {
        queued: 'w kolejce',
        delivered: 'dostarczona',
        consumed: 'przeczytana',
        refused: 'odrzucona',
      },
      events: 'Zdarzenia',
      containerLog: 'Log kontenera',
      version: 'Wersja',
      activeAgents: 'Działający agenci',
      updated: 'Zaktualizowano',
      archived: 'zarchiwizowana',
      noDefinitions: 'Brak definicji.',
      versions: 'Wersje',
      from: 'z',
      startInput: 'Dane startowe jako JSON',
      agentStarted: 'Agent uruchomiony.',
      startAgent: 'Uruchom agenta',
      editAsJson: 'Edytuj jako JSON',
      confirmArchive: 'Zarchiwizować tę definicję? Działający agenci będą działać dalej.',
      archive: 'Archiwizuj',
      definitionJson: 'Definicja jako JSON',
      definitionJsonHint: 'Definicja w języku grafów Veridion. Walidacja pokazuje jej błędy i jej graf; zapisanie przechowuje ją jako nową zatwierdzoną wersję.',
      checked: 'Sprawdzono.',
      validate: 'Waliduj',
      saved: 'Zapisano jako nową wersję.',
      saveVersion: 'Zapisz jako nową wersję',
      valid: 'Definicja jest prawidłowa.',
      you: 'Ty',
      architect: 'Architekt',
      architectPlaceholder: 'Opisz, co agent ma robić …',
      newDesign: 'Nowy projekt',
      unitKinds: {
        company: 'firma',
        department: 'dział',
        team: 'zespół',
        project: 'projekt',
      },
      partOf: 'część',
      confirmRemove: 'Usunąć tę jednostkę? Jej członkowie utracą ten zakres.',
      remove: 'usuń',
      addUnit: 'Dodaj jednostkę',
      unitId: 'Identyfikator (małe litery, myślniki)',
      unitName: 'Nazwa',
      add: 'Dodaj',
      addMember: 'Dodaj członka',
      memberKinds: {
        person: 'osoba (adres e-mail)',
        agent: 'agent (identyfikator)',
        definition: 'definicja (identyfikator)',
      },
      memberId: 'Adres e-mail lub identyfikator',
      role: 'Rola',
      confirmEmergencyOn: 'Zatrzymać teraz wszystkich agentów? Bot nadal będzie odpowiadał.',
      confirmEmergencyOff: 'Zwolnić zatrzymanie awaryjne?',
      emergencyStop: 'Zatrzymanie awaryjne',
      emergencyRelease: 'Zwolnij zatrzymanie awaryjne',
      emergencyActive: 'zatrzymanie awaryjne jest włączone',
      autopilotOn: 'Włącz autopilota',
      autopilotOff: 'Wyłącz autopilota',
      autopilotActive: 'Autopilot jest aktywny: Veridion Core sam odpowiada na każdą kartę skierowaną do ludzi',
      autopilotUnitsTitle: 'Autopilot według jednostek biznesowych',
      autopilotUnitsHint: 'Włącza lub wyłącza autopilota indywidualnie dla każdej jednostki biznesowej i warstwy wykonawczej. Wstrzymana praca pozostaje nietknięta.',
      autopilotUnitOn: 'Autopilot wł.',
      autopilotUnitOff: 'Autopilot wył.',
      limitsBuilds: 'Buildy obrazów na współpracownika i dzień',
      limitsDesigns: 'Projekty agentów na współpracownika i dzień',
      limitsSave: 'Ustaw dzienne limity',
      limitsNone: '0 = bez limitu',
      confirmAutopilotOn: 'Włączyć autopilota? Własny decydent Veridion Core od razu odpowie na każdą otwartą i każdą nową kartę w pAIoneer-humans-and-bots, widocznie w wątku karty.',
      confirmAutopilotOff: 'Wyłączyć autopilota? Od tej chwili znów decydują ludzie.',
      model: 'Model',
      codingModel: 'Model do kodowania',
      modelsTitle: 'Modele według roli',
      modelsSubtitle: 'Na jakim modelu myśli każda rola Veridion Core: twarz i sterowanie firmy, telefon, architekt i sędzia werdyktów wymagań. Wybrać można tylko modele routowane przez bramę; puste oznacza domyślne ustawienie konfiguracji.',
      roleCoordinator: 'Koordynator (twarz i sterowanie)',
      roleCall: 'Telefon',
      roleArchitect: 'Architekt',
      roleRequirementsJudge: 'Sędzia wymagań',
      roleJudge: 'Oceny Core',
      roleEar: 'Ucho telefonu',
      roleStt: 'Ucho Webex',
      modelGroupVllm: 'vLLM (własna karta)',
      modelGroupAudio: 'Audio (własna karta / chmura)',
      modelGroupCloud: 'OpenRouter (chmura)',
      directLlmTitle: 'Bezpośredni dostęp do LLM',
      directLlmSubtitle: 'Rozmawiaj bezpośrednio z vLLM lub modelem w chmurze, bez botów, agentów i Webex',
      directLlmHint: 'Bezpośredni dostęp administratora: wybrany model odpowiada surowo, księgowany jako „console”, bez lanes, ról i narzędzi.',
      directLlmModel: 'Model',
      directLlmSystem: 'Prompt systemowy (opcjonalnie)',
      directLlmSystemPlaceholder: 'np. Jesteś …',
      directLlmPrompt: 'Wiadomość',
      directLlmPromptPlaceholder: 'O co chcesz bezpośrednio zapytać model?',
      directLlmSend: 'Wyślij',
      directLlmSending: 'Wysyłanie …',
      directLlmUsage: '{prompt}+{completion} tokenów · {cost}',
      modelCurrent: 'W użyciu',
      modelDefault: 'Domyślny',
      modelChosen: 'Wybrany',
      modelDefaultOption: 'domyślne ustawienie konfiguracji',
      modelNotRouted: 'nierutowany przez bramę',
      modelSave: 'Zapisz',
      engineSilver: 'Silnik firmowy (srebro)',
      engineGold: 'Silnik firmowy (złoto, orkiestratora)',
      callsTitle: 'Rozmowy telefoniczne',
      callsSubtitle: 'Każda wypowiedziana tura telefonu, księgowana osobno od pracy kolegów: tokeny, koszt i czas ucha, umysłu i głosu, według kolegi i modelu, za ostatnie 30 dni i dziś; poniżej najnowsze tury.',
      callsTurns: 'Tury',
      callsCalls: 'Rozmowy',
      callsAvgTotal: 'Ø razem ms',
      callsAvgAsr: 'Ø ucho ms',
      callsAvgLlm: 'Ø umysł ms',
      callsAvgTts: 'Ø głos ms',
      callsDeferred: 'Odroczone',
      callsToday: 'Dziś',
      callsWindow: 'Ostatnie 30 dni',
      callsRecent: 'Najnowsze tury',
      callsPerson: 'Osoba',
      callsRounds: 'Rundy',
      callsNone: 'Nie zaksięgowano jeszcze żadnej rozmowy.',
      unitKindExecutive: 'Poziom kierowniczy',
      unitKindBusinessUnit: 'Jednostka biznesowa',
      orgSynced: 'Poziom kierowniczy i jednostki biznesowe są zdefiniowane w organizacji Veridion Core i zsynchronizowane tutaj; zmienia się je tam, nie na tej stronie.',
      memory: 'Pamięć',
      ready: 'gotowa',
      notReady: 'niegotowa',
      factExtraction: 'ekstrakcja faktów włączona',
      cluster: 'Dostęp do klastra',
      agentsRunning: 'Działający agenci',
      agentsWaiting: 'oczekujący',
      definitions: 'Definicje',
      gatewayIdentity: 'Tożsamość w gatewayu',
      gatewayTokens: 'Tokeny gatewaya w oknie czasowym',
      hostedTitle: 'Hostowani agenci',
      hostedSubtitle: 'Aplikacje AI, które Veridion Core uruchamia i obsługuje we własnych kontenerach.',
      agent: 'Agent',
      actions: 'Akcje',
      confirmHosted: '{action}: {agent}?',
      hostedActions: {
        start: 'uruchom',
        stop: 'zatrzymaj',
        restart: 'uruchom ponownie',
      },
      open: 'otwórz',
      agentsTitle: 'Agenci',
      agentsSubtitle: 'Każdy agent i agent podrzędny działa we własnym kontenerze. Otwórz agenta, aby wysłać mu wiadomość lub wydać polecenie.',
      showFinished: 'Pokaż zakończonych agentów',
      noAgents: 'Brak agentów.',
      definitionsTitle: 'Definicje',
      definitionsSubtitle: 'Zatwierdzone grafy agentów wraz z ich wersjami.',
      designsTitle: 'Projekty agentów',
      designsSubtitle: 'Każdy agent zaprojektowany przez architekta, dla osoby lub dla pracy współpracownika AI: po co i dlaczego, każde pytanie z odpowiedzią, przebiegi testowe wobec scenariuszy, zatwierdzenie i uruchomienia.',
      design: 'Projekt',
      designFor: 'Dla',
      designWork: 'Praca',
      designState: 'Stan',
      designApprovedBy: 'Zatwierdził',
      designAgent: 'Zbudowany agent',
      filterState: 'Stan',
      filterAll: 'Wszystkie',
      filterOpen: 'Otwarte',
      filterDone: 'Gotowe',
      filterFailed: 'Nieudane',
      filterCurrent: 'Aktywne i niedawno nieudane',
      filterActive: 'Aktywne',
      filterFinished: 'Zakończone',
      filterPosition: 'Współpracownik AI',
      pagePrev: 'Wstecz',
      pageNext: 'Dalej',
      pageLabel: 'Strona',
      searchLabel: 'Szukaj',
      showMore: 'Pokaż więcej',
      noDesigns: 'Nie zaprojektowano jeszcze żadnego agenta.',
      designReason: 'Dlaczego narzędzia nie wystarczyły',
      designRecord: 'Przebieg',
      designAgents: 'Agenci projektu',
      designTestRun: 'Test',
      designRun: 'Uruchomienie',
      designStatus: { designing: 'w projektowaniu', testing: 'w teście', asking: 'czeka na odpowiedź', approval: 'czeka na zatwierdzenie', running: 'działa', done: 'gotowe', failed: 'nieudane', cancelled: 'anulowane' },
      builtBy: 'Zbudowany przez',
      builtFor: 'Dla pracy',
      viaCodingTask: 'przez agenta programistycznego',
      designTests: 'Testy',
      designRuns: 'Uruchomienia',
      designByPerson: 'osoba w rozmowie',
      diagramsTitle: 'Diagramy',
      diagramsSubtitle: 'Obrazy przepływów, architektur i planów narysowane przez współpracowników AI, agentów i agenta programistycznego, z tytułem, legendą i kodem Mermaid.',
      noDiagrams: 'Brak diagramów.',
      diagramAuthor: 'Autor',
      diagramBasedOn: 'Rozszerza',
      diagramCode: 'Kod Mermaid',
      architectTitle: 'Architekt',
      architectSubtitle: 'Projektowanie agenta w rozmowie. Architekt pyta o to, czego nie może rozstrzygnąć sam, i tworzy agenta dopiero po zatwierdzeniu.',
      orgTitle: 'Organizacja',
      orgSubtitle: 'Działy, zespoły i projekty wraz z ich członkami; pamięć firmy jest współdzielona zgodnie z tą strukturą.',
      usageTitle: 'Zużycie według agenta',
      usageSubtitle: 'Wywołania modeli, tokeny i zgłoszone koszty z ostatnich 30 dni.',
      calls: 'Wywołania',
      source: 'Źródło',
      gpuTokens: 'Tokeny na karcie graficznej',
      cloudTokens: 'Tokeny w chmurze',
      usageByModel: 'Według współpracownika i modelu',
      cost: 'Koszt',
    },
    memory: {
      archOverviewTitle: "Przegląd architektury: jak zbudowana jest pamięć firmy",
      archOverviewText: "Veridion Core przechowuje wiedzę firmy w trzech warstwach: Neo4j jako czasowy graf wiedzy dla faktów, decyzji i pakietów pracy, PostgreSQL dla transakcyjnych stanów agentów, skrzynek i sprintów oraz Qdrant dla wyszukiwania wektorowego po dokumentach firmy. Każda jednostka biznesowa pracuje w odizolowanej merytorycznie domenie wiedzy; wyniki między jednostkami przechodzą przez zaprotokołowane przekazania.",
      clustersTitle: "Domeny wiedzy jednostek biznesowych",
      clustersSubtitle: "Każda jednostka biznesowa pracuje w wydzielonej domenie wiedzy Neo4j; liczby węzłów i krawędzi pochodzą na żywo z Neo4j, opisy z oznaczonego zasiewu początkowego. Kliknięcie otwiera domenę w grafie wiedzy.",
      clusterCode: "Kod",
      clusterName: "Domena wiedzy",
      clusterId: "Identyfikator",
      clusterRoles: "Role",
      clusterBridges: "Mosty przekazań",
      clusterPolicy: "Zakres merytoryczny i reguła izolacji",
      clusterCounts: "Węzły / krawędzie (na żywo)",
      clusterInsights: "Ustalenia (zasiew początkowy)",
      clusterOpenButton: "Otwórz w grafie wiedzy",
      countsUnavailable: "Neo4j nieosiągalny — brak zliczenia",
      researchTitle: "Archiwum badań AI kwantowej i frontier",
      researchSubtitle: "Kluczowe publikacje naukowe i referencje architektury — wiersze na żywo z Veridion Core; pochodzenie każdego wiersza jest widoczne.",
      researchEmpty: "W archiwum nie ma jeszcze publikacji.",
      researchIngestNote: "Nowe publikacje dodaje kolega kwantowy swoim narzędziem; panel jedynie czyta archiwum.",
      researchPublication: "Publikacja",
      researchMechanism: "Mechanizm kluczowy",
      researchRelevance: "Znaczenie dla architektury",
      researchOrigin: "Pochodzenie",
      researchSeeded: "zasiew początkowy",
      researchMotivates: "Uzasadnia wersję",
      title: 'Pamięć firmy',
      subtitle: 'Co Veridion Core przechowuje w Neo4j: wspomnienia według zakresu, fakty wraz z okresem obowiązywania oraz audyt działań agentów.',
      failed: 'To się nie udało',
      loading: 'Ładowanie …',
      unavailable: 'Pamięć jest nieosiągalna',
      database: 'Baza danych',
      ready: 'gotowa',
      notReady: 'niegotowa',
      factExtraction: 'Ekstrakcja faktów',
      episodesQueued: 'Oczekujące epizody',
      lastError: 'Ostatni błąd',
      contentTitle: 'Zawartość',
      contentSubtitle: 'Węzły według etykiety oraz wspomnienia według zakresu i rodzaju.',
      label: 'Etykieta',
      count: 'Liczba',
      empty: 'Jeszcze nic.',
      scope: 'Zakres',
      kind: 'Rodzaj',
      kinds: {
        fact: 'fakt',
        decision: 'decyzja',
        task: 'zadanie',
        procedure: 'procedura',
        note: 'notatka',
        episode: 'epizod',
      },
      searchTitle: 'Wyszukiwanie',
      searchSubtitle: 'Przywoływanie, z którego korzystają agenci: znaczenie, słowa i wyodrębnione fakty.',
      searchPlaceholder: 'Hasło wyszukiwania lub pytanie',
      allScopes: 'wszystkie zakresy',
      search: 'Szukaj',
      noResults: 'Nic nie znaleziono.',
      text: 'Tekst',
      validFrom: 'Obowiązuje od',
      source: 'Źródło',
      extracted: 'wyodrębniony',
      recorded: 'zarejestrowany',
      rememberTitle: 'Zapamiętaj',
      rememberSubtitle: 'Zapisz fakt, decyzję, zadanie, procedurę lub notatkę w wybranym zakresie.',
      remembered: 'Zapisano.',
      remember: 'Zapamiętaj',
      created: 'Utworzono',
      validity: 'Ważność',
      invalid: 'nieważne',
      confirmInvalidate: 'Oznaczyć to wspomnienie jako już nieważne?',
      invalidate: 'oznacz jako nieważne',
      forget: 'zapomnij',
      confirmForget: 'Zapomnieć ten wpis na zawsze? Zostanie usunięty z pamięci i nie da się go przywrócić.',
      forgotten: 'Zapomniano.',
      factsTitle: 'Fakty w czasie',
      factsSubtitle: 'Fakty wyodrębnione z rozmów i wyników agentów; fakt, któremu zaprzeczono, otrzymuje datę końcową.',
      noFacts: 'Nie wyodrębniono jeszcze żadnych faktów.',
      briefsTitle: 'Podsumowania współpracowników AI',
      briefsSubtitle: 'Co każdy współpracownik AI czyta najpierw: otwarte zobowiązania, obowiązujące decyzje, bieżące sprawy i klientów, spisane każdej nocy z pamięci.',
      brief: 'Podsumowanie',
      updated: 'Zaktualizowano',
      noBriefs: 'Nie spisano jeszcze żadnych podsumowań.',
      fact: 'Fakt',
      from: 'Od',
      to: 'Do',
      validUntil: 'Obowiązuje do',
      stillValid: 'nadal obowiązuje',
      entityTitle: 'Sąsiedztwo',
      entitySubtitle: 'Z czym powiązane jest zadanie, projekt, osoba, system lub encja.',
      entityPlaceholder: 'Nazwa, identyfikator zadania, adres e-mail lub identyfikator',
      show: 'Pokaż',
      auditTitle: 'Audyt',
      auditSubtitle: 'Wywołania modeli i narzędzi, wiadomości oraz uruchomieni agenci podrzędni.',
      auditPlaceholder: 'Identyfikator agenta (puste: wszyscy)',
      filter: 'Filtruj',
      time: 'Czas',
      agent: 'Agent',
      event: 'Zdarzenie',
      toolOrModel: 'Narzędzie lub model',
      status: 'Status',
      detail: 'Szczegóły',
      consoleTitle: 'Konsola zapytań',
      consoleSubtitle: 'Cypher tylko do odczytu; instrukcje zapisujące są odrzucane.',
      run: 'Wykonaj',
      truncated: 'kolejne wiersze zostały obcięte',
      graph: {
        clusterPickTitle: "Skup domenę wiedzy w grafie",
        clusterPickHint: "Kliknięcie jednostki biznesowej skupia jej podgraf z rolami i mostami przekazań w interaktywnym grafie.",
        allClusters: "Wszystkie domeny (pełny graf)",
        activeCluster: "Aktywna domena wiedzy",
        publicationsTitle: "Publikacje w archiwum badań",
        storesTitle: 'Magazyny pamięci firmy',
        storesSubtitle: 'Co zawiera każdy magazyn pamięci firmy, odczytane na żywo: graf w Neo4j, stan Veridion Core w Postgresie, wektory bazy wiedzy w Qdrant.',
        storeNeo4j: 'Neo4j (graf)',
        storeNeo4jHolds: 'Pamięć firmy: wspomnienia z ich zakresem, encje i fakty wyodrębnione przez Graphiti z okresem ważności, elementy pracy z ich znaczeniem, praca programistyczna i audyt agentów.',
        storePostgres: 'Postgres (relacyjna)',
        storePostgresHolds: 'Stan transakcyjny Veridion Core: tabela procesów agentów, skrzynki, rozmowy, punkty kontrolne, zadania programistyczne, zatwierdzenia, organizacja i zużycie.',
        storeQdrant: 'Qdrant (wektory)',
        storeQdrantHolds: 'Baza wiedzy firmy: osadzone fragmenty dokumentów dodanych przez administratora, przeszukiwane przez orkiestratora, gdy tura rozmowy potrzebuje bazy wiedzy.',
        nodes: 'węzłów',
        relationships: 'relacji',
        relationshipType: 'Typ relacji',
        tables: 'tabel',
        table: 'Tabela',
        rows: 'wierszy',
        purpose: 'Co zawiera',
        documents: 'dokumentów',
        session: 'Sesja',
        collection: 'Kolekcja',
        role: 'Rola',
        roleDocuments: 'dokumenty',
        roleCurated: 'wyselekcjonowane pary pytanie-odpowiedź',
        title: 'Graf',
        subtitle: 'Graf pamięci firmy w Neo4j: zacznij od wyniku wyszukiwania, najnowszych wspomnień lub elementów pracy; kliknij węzeł, aby go odczytać, rozwiń jego sąsiadów, przeciągaj, aby ułożyć, przewijaj, aby powiększyć.',
        startNewest: 'Najnowsze wspomnienia',
        startWork: 'Elementy pracy',
        searchPlaceholder: 'Nazwa, tekst lub id do znalezienia w grafie',
        find: 'Szukaj',
        noHits: 'Nic nie znaleziono.',
        name: 'Nazwa',
        sources: { memory: 'wspomnienie', entity: 'wyodrębniona encja', node: 'pamięć projektu', episode: 'epizod' },
        show: 'pokaż',
        shown: '{nodes} węzłów i {edges} relacji w grafie',
        truncated: 'ucięte na granicy; rozwiń węzeł lub szukaj węziej',
        selected: 'Wybrany węzeł',
        selectHint: 'Kliknij węzeł w grafie.',
        expand: 'Rozwiń sąsiadów',
        expandTwo: 'Rozwiń dwa poziomy',
        centre: 'Wyśrodkuj na tym węźle',
        facts: 'Fakty tej encji',
        degree: 'Relacje',
        direction: 'Kierunek',
        out: 'wychodząca',
        in: 'przychodząca',
        noRelationships: 'Brak relacji.',
        property: 'Właściwość',
        value: 'Wartość',
        noProperties: 'Brak właściwości.',
        factsOf: 'Fakty:',
        factsSubtitle: 'Co Graphiti wyodrębniło o tej encji, z okresem ważności każdego faktu; fakt zaprzeczony ma datę końcową.',
        relation: 'Relacja',
        other: 'Druga encja',
        newestTitle: 'Najnowsze wspomnienia',
        newestSubtitle: 'Ostatnio zapisane wspomnienia z tym, czego dotyczą; „pokaż” rysuje jedno z jego powiązaniami.',
        about: 'Dotyczy',
        workTitle: 'Elementy pracy',
        workSubtitle: 'Każda potwierdzona praca ze stanem, właścicielem, zgłoszeniem i wynikami jej scenariuszy; „pokaż” rysuje jedną z jej znaczeniem, zgłoszeniem, zadaniami programistycznymi i zbudowanymi dla niej agentami.',
        allStates: 'wszystkie stany',
        states: { confirmed: 'potwierdzony', in_progress: 'w toku', blocked: 'zablokowany', done: 'zakończony', failed: 'nieudany', dropped: 'porzucony' },
        workItem: 'Element pracy',
        owner: 'Właściciel',
        issue: 'Zgłoszenie',
        scenarios: 'Scenariusze',
        results: { passed: 'zaliczony', failed: 'niezaliczony', pending: 'oczekuje' },
      },
      day: {
        title: 'Dzień firmy',
        subtitle: 'Oś czasu zdarzeń, które zapisuje Veridion Core: słowa ludzi, karty, praca, przekazania, badania, agenci, zadania programistyczne, projekty, incydenty i spotkania, od najnowszych.',
        sinceToday: 'dzisiaj',
        sinceDay: 'ostatnie 24 godziny',
        sinceWeek: 'ostatnie 7 dni',
        allKinds: 'wszystkie rodzaje',
        refresh: 'Odśwież',
        count: '{n} wydarzeń',
        time: 'Czas',
        actor: 'Aktor',
        happening: 'Zdarzenie',
        work: 'Praca',
        empty: 'W tym okresie nic nie zapisano.',
        kinds: { word: 'słowo', request: 'prośba', card: 'karta', work: 'praca', handover: 'przekazanie', research: 'badanie', agent: 'agent', task: 'zadanie programistyczne', project: 'projekt', incident: 'incydent', schedule: 'harmonogram', meeting: 'spotkanie', message: 'wiadomość' },
      },
    },
    title: 'Panel administracyjny',
    adminKicker: 'Eksploatacja',
    smtmStatusTitle: 'Dane i prognozy SMTM',
    smtmStatusSubtitle: 'Monitoruje szeregi czasowe brokera, opublikowane modele, wyniki prognoz i kanały RSS.',
    smtmStatusUnavailable: 'Stan SMTM niedostępny',
    smtmGeneratedAt: 'Wygenerowano',
    smtmMinimumRows: 'Minimalna liczba wierszy treningowych',
    smtmBaseFrames: 'Bazowe szeregi czasowe',
    smtmTrainableFrames: 'Dane surowe gotowe',
    smtmWaitingHistory: 'Oczekiwanie na historię',
    smtmPredictionTrackedInstruments: 'Śledzone instrumenty',
    smtmPredictionEnabledCount: 'Prognozy włączone',
    smtmPredictionDisabledCount: 'Prognozy wstrzymane',
    smtmMlFrames: 'Zbiory danych ML',
    smtmOnlineModels: 'Modele online',
    smtmModelsWithArtifacts: 'Modele z artefaktami',
    smtmPredictionFrames: 'Szeregi prognoz',
    smtmMissingPredictions: 'Szeregi bez prognoz',
    smtmBlobArtifacts: 'Artefakty blob',
    smtmStalePredictions: 'Przeterminowane prognozy',
    smtmRssFrames: 'Kanały RSS',
    smtmDataframesTotal: 'Łącznie zbiorów danych',
    smtmLatestModelUpload: 'Ostatnie wgranie modelu',
    smtmLatestPredictionWrite: 'Ostatni zapis prognozy',
    smtmRuntimeHints: 'Wskazówki runtime',
    smtmNoHints: 'Brak otwartych wskazówek SMTM.',
    smtmInstrument: 'Instrument',
    smtmBaseData: 'Dane bazowe',
    smtmMlFrame: 'Zbiór danych ML',
    smtmModelPublish: 'Stan modelu',
    smtmArtifacts: 'Artefakty',
    smtmPredictionFrame: 'Szereg prognoz',
    smtmIssues: 'Problemy',
    smtmNoIssues: 'Brak problemów',
    smtmNoFrames: 'Nie znaleziono instrumentów SMTM.',
    smtmPredictionControlTitle: 'Sterowanie prognozami SMTM',
    smtmPredictionControlSubtitle: 'Zdecyduj dla każdego instrumentu, czy SMTM ma liczyć nowe prognozy uczenia maszynowego, czy tylko zbierać dane bazowe.',
    smtmPredictionSettingsUnavailable: 'Sterowanie prognozami SMTM niedostępne',
    smtmPredictionControlHint: 'Wstrzymane instrumenty zachowują dane historyczne. Nie powstają dla nich nowe zbiory ML, treningi ani prognozy.',
    smtmPredictionMode: 'Tryb prognozy',
    smtmPredictionToggle: 'Sterowanie administratora',
    smtmPredictionToggleLabel: 'Włącz lub wstrzymaj prognozy',
    smtmPredictionEnabled: 'Prognoza włączona',
    smtmPredictionDisabled: 'Prognoza wstrzymana',
    smtmPredictionSaving: 'Zapisywanie...',
    smtmPredictionSettingsSaved: 'Sterowanie prognozami SMTM zapisane.',
    smtmPredictionSaveChanges: 'Zapisz zmiany',
    smtmPredictionResetChanges: 'Odrzuć zmiany',
    smtmPredictionPendingChanges: 'oczekujące zmiany',
    smtmPredictionPendingBadge: 'Oczekuje na zapis',
    smtmOpenAzuriteUi: 'Otwórz interfejs Azurite',
    azuriteTitle: 'Interfejs Azurite (SMTM)',
    azuriteSubtitle: 'Widok tylko do odczytu wpisów modelstatus, artefaktów blob i pobierania modeli.',
    azuriteModelGroups: 'Grupy modeli',
    azuriteBlobArtifacts: 'Artefakty blob',
    azuriteFiles: 'Pliki',
    azuriteSearchPlaceholder: 'Filtruj modele',
    azuriteNoModels: 'Nie znaleziono modeli w Azurite.',
    smtmRows: 'Wiersze',
    smtmLatest: 'Ostatni znacznik czasu',
    smtmAge: 'Wiek',
    smtmValue: 'Wartość',
    smtmMinutesAgo: 'min temu',
    smtmMinutesAhead: 'min naprzód',
    smtmHoursAgo: 'godz. temu',
    smtmDaysAgo: 'dni temu',
    smtmStateLabels: {
      available: 'Dostępny',
      trainable: 'Gotowy do treningu',
      waiting_for_history: 'Oczekuje na historię',
      missing_base_data: 'Brak danych bazowych',
      missing_machine_learning: 'Brak zbioru danych ML',
      missing_prediction: 'Brak prognozy',
      prediction_disabled: 'Prognoza wstrzymana',
      stale_prediction: 'Przeterminowana prognoza',
      open: 'Otwarty',
      completed: 'Zakończony',
      online: 'Online',
      offline: 'Offline',
      training: 'Trenowanie',
      uploading: 'Wysyłanie',
      failed: 'Niepowodzenie',
      unknown: 'Nieznany',
      missing: 'Brak'
    },
    smtmIssueLabels: {
      empty_base_frame: 'Pusty bazowy szereg czasowy',
      insufficient_history: 'Za mało historii',
      missing_machine_learning_frame: 'Brak zbioru danych ML',
      missing_prediction_frame: 'Brak szeregu prognoz',
      stale_prediction_frame: 'Przeterminowany szereg prognoz',
      missing_online_model: 'Brak modelu online',
      model_offline: 'Model offline',
      missing_model_blob: 'Brak bloba modelu',
      missing_model_header: 'Brak nagłówka modelu',
      missing_modelstatus_entry: 'Brak wpisu modelstatus',
      inference_not_writing_prediction: 'Inferencja nie zapisuje prognoz',
      prediction_disabled_by_admin: 'Prognoza wstrzymana przez administratora'
    },
    smtmHintLabels: {
      trainable_frames_missing_predictions: 'instrumenty gotowe do treningu bez wyników prognoz',
      instruments_waiting_for_history: 'instrumenty wciąż oczekujące na historię',
      models_missing_artifacts: 'modele online bez kompletnych artefaktów',
      no_online_models: 'Brak modeli online w Azurite',
      azurite_unavailable: 'Stan magazynu Azurite jest obecnie niedostępny'
    },
    mailTitle: 'Konfiguracja poczty',
    usersTitle: 'Zarządzanie użytkownikami',
    usersSubtitle: 'Konta, role, status i 2FA z Keycloak. Wybranie konta otwiera sterowanie właśnie tym kontem.',
    usersHideCreate: 'Zamknij formularz',
    usersCreateHint: 'Nowe konto startuje z obowiązkowym 2FA i staje się aktywne po jego skonfigurowaniu.',
    usersFilterAllStatus: 'Wszystkie stany',
    usersFilterAllRoles: 'Wszystkie role',
    usersManage: 'Zarządzaj',
    usersClose: 'Zamknij',
    usersNoneFound: 'Nie znaleziono użytkowników.',
    usersPagePrev: 'Poprzednia',
    usersPageNext: 'Następna',
    auditTitle: 'Dziennik audytu',
    smtpHost: 'Serwer SMTP',
    smtpPort: 'Port SMTP',
    smtpSecurity: 'Zabezpieczenie SMTP',
    smtpUsername: 'Użytkownik SMTP',
    smtpPassword: 'Hasło SMTP',
    fromEmail: 'Adres nadawcy',
    fromName: 'Nazwa nadawcy',
    replyToEmail: 'Adres zwrotny',
    saveMailSettings: 'Zapisz konfigurację poczty',
    sendTestMail: 'Wyślij wiadomość testową',
    createUser: 'Utwórz użytkownika',
    setPassword: 'Ustaw hasło',
    setRoles: 'Ustaw role',
    setStatus: 'Ustaw status',
    resetMfa: 'Zresetuj 2FA',
    revokeSessions: 'Unieważnij sesje',
    filterUsers: 'Filtruj użytkowników',
    testRecipient: 'Odbiorca wiadomości testowej',
    statusConfigured: 'Skonfigurowane',
    statusMissing: 'Nieskonfigurowane',
    userEmail: 'E-mail',
    userName: 'Nazwa użytkownika',
    userRoles: 'Role',
    userStatus: 'Status',
    auditEvent: 'Zdarzenie',
    auditCreatedAt: 'Utworzono',
    auditDetails: 'Szczegóły',
    aiGatewayTitle: 'AI Gateway',
    aiGatewayEndpoint: 'Punkt końcowy',
    aiGatewayIdentitySource: 'Tożsamość z claimu tokenu',
    aiGatewayBudgetSource: 'Wartości początkowe w',
    aiGatewayModels: 'Routowane modele',
    aiGatewayModel: 'Model',
    aiGatewayBackend: 'Backend',
    aiGatewayBudgets: 'Budżety tokenów',
    aiGatewayIdentity: 'Tożsamość',
    aiGatewayTokenBudget: 'Budżet tokenów',
    aiGatewayWindow: 'Okno',
    aiGatewayAnyIdentity: 'dowolna tożsamość',
    aiGatewayAnyModel: 'dowolny model',
    aiUsageWindowStarted: 'Okno od',
    aiUsageRemaining: 'Pozostało',
    aiUsageIdentities: 'Tożsamości',
    aiGatewaySubtitle: 'Envoy AI Gateway to jedyna droga do modelu: routowane modele, ich backendy serwujące i budżet tokenów każdej tożsamości.',
    aiGatewayHint: 'Budżetami steruje się tutaj. Warstwa wdrożeniowa tylko zasiewa wartości dla nowego klastra.',
    aiUsageTitle: 'Zużycie AI według tożsamości',
    aiUsageSubtitle: 'Tokeny zaksięgowane przez bramę w bieżącym oknie.',
    sessionActiveUsers: 'Zalogowani użytkownicy',
    sessionActiveSessions: 'Aktywne sesje',
    sessionMfaSessions: 'Zweryfikowane sesje',
    aiUsageTotalTokens: 'Tokeny łącznie',
    aiServicesTitle: 'Dostęp do usług',
    aiServicesSubtitle: 'Linki do interfejsów API i eksploatacyjnych platformy; każdy cel sam sprawdza rolę administratora.',
    aiMailSubtitle: 'Ustawienia SMTP, z których Keycloak wysyła wiadomości weryfikacyjne i resetujące, oraz wysyłka testowa.',
    tabOverview: 'Przegląd',
    tabSmtm: 'SMTM',
    tabEnvoy: 'Envoy AI Gateway',
    tabMail: 'Wysyłka poczty',
    tabUsers: 'Użytkownicy',
    tabAudit: 'Dziennik audytu',
    tabServiceLinks: 'Dostęp do usług',
    tabVeridion: 'Veridion SMTM',
    tabVeridionPaioneer: 'Veridion pAIoneer Labs GmbH',
    tabAgenticRag: 'Agentic RAG',
    tabPlatform: 'Platforma',
    platformTitle: 'Stan platformy',
    platformSubtitle: 'Każde obciążenie pAIoneer Labs GmbH wraz z gotowymi replikami, restartami i obrazem, prosto z Kubernetes.',
    platformHostPage: 'Zarządzaj instancjami w hoście aplikacji',
    openVisitorMonitoring: 'Otwórz monitoring odwiedzających, marketingu i SEO',
    platformUnavailable: 'Stan platformy niedostępny',
    platformWorkloadsTotal: 'Obciążenia',
    platformDegradedTotal: 'Niegotowe',
    platformRestartsTotal: 'Restarty',
    platformWorkload: 'Obciążenie',
    platformNamespace: 'Przestrzeń nazw',
    platformReplicas: 'Repliki',
    platformRestarts: 'Restarty',
    platformImage: 'Obraz',
    platformState: 'Stan',
    platformStateReady: 'Gotowe',
    platformStateDegraded: 'Osłabione',
    platformStateDown: 'Wyłączone',
    platformStateUnknown: 'Nieznane',
    platformNodes: 'Węzły',
    platformOsImage: 'System operacyjny',
    platformKernel: 'Jądro',
    platformRuntime: 'Runtime kontenerów',
    platformKubelet: 'Kubelet',
    platformUsed: 'Aktualnie używane',
    platformReportedCapacity: 'Zgłoszone przez Kubernetes',
    platformConfiguredCap: 'Skonfigurowany limit kontenera',
    platformPressure: 'Warunki obciążenia',
    platformPressureNone: 'brak',
    platformCpu: 'Rdzenie CPU',
    platformNoWorkloads: 'Ta przestrzeń nazw zawiera obiekty konfiguracyjne, bez obciążeń.',
    platformMemory: 'Pamięć',
    platformEvents: 'Ostatnie ostrzeżenia',
    platformEventsNone: 'Brak ostrzeżeń.',
    platformEventObject: 'Obiekt',
    platformEventReason: 'Powód',
    platformEventMessage: 'Komunikat',
    platformEventLastSeen: 'Ostatnio widziane',
    platformMetricsMissing: 'Brak danych o zużyciu: metrics-server nie odpowiada.',
    aiGatewayBackends: 'Backendy serwujące',
    gpuTitle: 'Karta graficzna',
    gpuNote: 'Obciążenie silników na karcie graficznej, tokeny pobrane z nich według tożsamości i bota Webex oraz budżety tokenów według tożsamości i silnika.',
    gpuTokensWindow: 'Tokeny na karcie graficznej w oknie',
    gpuSinceStart: 'od uruchomienia silnika',
    gpuIdentities: 'Według tożsamości, bieżące okno',
    gpuBots: 'Według bota Webex i agenta, 30 dni',
    gpuBot: 'Bot Webex / agent',
    gpuBudgetTitle: 'Budżet na silnik według tożsamości',
    gpuBudgetSet: 'Ustaw budżet',
    gpuBudgetHint: 'Tokeny na godzinę na silniku; brama to egzekwuje. Ogranicza także tożsamość bez limitu.',
    gpuNoneYet: 'Jeszcze nic nie zaksięgowano.',
    gpuEngines: 'Silniki',
    gpuEngine: 'Silnik',
    gpuEngineGold: 'Silnik złoty',
    agenticRagTitle: 'Agentic RAG',
    agenticRagSubtitle: 'Środowisko uruchomieniowe, baza wiedzy, przygotowanie treningu i identyfikowalność aplikacji Agentic RAG.',
    agenticRagBackendStatus: 'Stan backendu',
    agenticRagRuntimeMode: 'Tryb uruchomienia',
    agenticRagKnowledgeMode: 'Tryb wiedzy',
    agenticRagDeploymentEnv: 'Środowisko wdrożenia',
    agenticRagVectorStores: 'Magazyny wektorów',
    agenticRagQdrantStatus: 'Qdrant',
    agenticRagQdrantCollection: 'Kolekcja dokumentów',
    agenticRagQdrantCuratedCollection: 'Kolekcja wyselekcjonowanych pytań i odpowiedzi',
    agenticRagQdrantDashboard: 'Panel',
    agenticRagPhoenixStatus: 'Phoenix',
    agenticRagOpenDocs: 'Otwórz Swagger',
    agenticRagOpenPhoenix: 'Otwórz Phoenix',
    agenticRagOpenQdrant: 'Otwórz Qdrant',
    agenticRagKnowledgeTitle: 'Baza wiedzy',
    agenticRagKnowledgeSubtitle: 'Stan dokumentów oraz wyselekcjonowanych pytań i odpowiedzi aplikacji Agentic RAG.',
    agenticRagDocuments: 'Dokumenty',
    agenticRagCuratedQaPairs: 'Wyselekcjonowane pary pytanie-odpowiedź',
    agenticRagTrainingTitle: 'Przygotowanie treningu',
    agenticRagTrainingSubtitle: 'Ostatnie uruchomienie generatora i ostatni stan trenera.',
    agenticRagLatestDataset: 'Ostatni zbiór danych',
    agenticRagDatasetPairs: 'Pary pytanie-odpowiedź',
    agenticRagDatasetDocuments: 'Przetworzone dokumenty',
    agenticRagDatasetModifiedAt: 'Ostatnia zmiana',
    agenticRagLatestTrainerInput: 'Ostatnie dane wejściowe trenera',
    agenticRagTrainerInputModifiedAt: 'Dane wejściowe zmienione',
    agenticRagLatestTrainerRun: 'Ostatnie uruchomienie trenera',
    agenticRagTrainerRunModifiedAt: 'Podsumowanie uruchomienia zmienione',
    gpuEngineSilver: 'Silnik srebrny',
    gpuAssignment: 'Przypisanie',
    gpuWho: 'Kto',
    gpuRank: 'Ranga',
    gpuRankHint: 'Ranga 0 jest obsługiwana jako pierwsza; każdy silnik obsługuje według rangi.',
    gpuLanes: 'Trwające wywołania Veridion Core według silnika i rangi',
    gpuInFlight: 'w toku',
    gpuWhoMainBotPeople: 'Główny bot: rozmowy z ludźmi',
    gpuWhoMainBotJudgements: 'Główny bot: oceny w tej samej turze',
    gpuWhoAutopilot: 'Autopilot',
    gpuWhoAgents: 'Agenci uruchamiani przez głównego bota',
    gpuWhoArchitect: 'Architekt',
    gpuWhoChair: 'Przewodniczący spotkania',
    gpuWhoOrchestrator: 'Orkiestrator instancji firmowej',
    gpuWhoColleagues: 'Współpracownicy AI: tury i ich oceny',
    gpuWhoMeetingWords: 'Współpracownicy AI: wypowiedzi na spotkaniach',
    gpuWhoBackgroundReading: 'Usługa w tle: czytanie postów botów',
    gpuWhoMemory: 'Pamięć firmy: przyjmowanie i briefy',
    gpuWhoCoding: 'Zadania programistyczne: oceny i uczenie się',
    gpuWhoResearch: 'Badania internetowe i OSINT',
    gpuWhoKnowledgeBase: 'Firmowa baza wiedzy: czytanie zeskanowanych stron',
    gpuWhoPipeline: 'Przegląd pipeline\'u względem IDD',
    gpuWhoSmtm: 'Veridion SMTM: czat i baza wiedzy SaaS, ostatnia ranga',
    gpuUnavailable: 'Karta graficzna nie odpowiada',
    aiGatewaySource: 'Źródło',
    aiSourceGpu: 'Karta graficzna',
    aiGatewayMeter: 'Licznik',
    aiGatewayMeterIdentity: 'Każda tożsamość, liczona',
    aiGatewayEngines: 'Silniki na karcie graficznej',
    aiGatewayEnginesHint: 'Bieżące wskaźniki każdego silnika z jego metryk: żądania trwające i oczekujące, zapełnienie pamięci podręcznej oraz tokeny obsłużone od uruchomienia.',
    aiEngineRunning: 'Trwające',
    aiEngineWaiting: 'Oczekujące',
    aiEngineCache: 'Pamięć podręczna zajęta',
    aiEngineServed: 'Obsłużone tokeny',
    aiEngineIdle: 'Brak zapytań',
    aiEngineUnavailable: 'Silnik nie odpowiada',
    aiGatewayServing: 'Gotowy',
    aiBudgetControlTitle: 'Sterowanie budżetami tokenów',
    aiBudgetControlSubtitle: 'Budżet domyślny obowiązuje każdą tożsamość. Pojedyncza tożsamość może dostać własny limit.',
    aiBudgetDefault: 'Budżet domyślny',
    aiBudgetIdentity: 'Tożsamość',
    aiBudgetTokens: 'Tokeny',
    aiBudgetApply: 'Zastosuj',
    aiBudgetAdd: 'Ustaw limit',
    aiBudgetRemove: 'Usuń',
    aiBudgetSaved: 'Budżet tokenów zastosowany.',
    aiBudgetIdentityPlaceholder: 'Id klienta, np. paioneer-agent-veridion-smtm',
    aiBudgetUnlimited: 'Bez limitu',
    aiBudgetSetUnlimited: 'Znieś limit',
    aiBudgetRestoreLimit: 'Przywróć limit',
    aiUsageReset: 'Wyczyść okno',
    aiUsageResetDone: 'Bieżące okno wyczyszczone.',
    userMfa: '2FA',
    userMfaOn: 'Skonfigurowane',
    userMfaOff: 'Brak',
    userCreatedAt: 'Utworzono',
    mailSource: 'Zarządzane w',
    veridionTitle: 'Veridion SMTM',
    veridionSubtitle: 'Rdzeń konwersacyjny asystenta tradingowego: środowisko uruchomieniowe, rejestr narzędzi, serwery MCP i aktywność.',
    veridionOpenPage: 'Otwórz Veridion',
    veridionOpenDocs: 'Otwórz Swagger',
    veridionCoreStatus: 'Veridion MCP orchestrator',
    veridionTools: 'Narzędzia',
    veridionToolsTitle: 'Rejestr narzędzi',
    veridionToolsSubtitle: 'Pokazuje załadowane rodziny narzędzi i ich faktyczny stan.',
    veridionToolName: 'Narzędzie',
    veridionToolRuntime: 'Runtime',
    veridionToolRisk: 'Ryzyko',
    veridionToolEnabled: 'Włączone',
    veridionNoTools: 'Nie załadowano narzędzi Veridion.',
    veridionRuntimeProfiles: 'Profile runtime',
    veridionRegistryReloaded: 'Rejestr przeładowany',
    veridionProvider: 'Ścieżka AI',
    veridionMcpTitle: 'Serwery MCP',
    veridionMcpSubtitle: 'Podłączone zewnętrzne serwery narzędzi z ich stanem i liczbą narzędzi.',
    veridionMcpServer: 'Serwer',
    veridionMcpState: 'Stan',
    veridionMcpTools: 'Narzędzia',
    veridionMcpLastSuccess: 'Ostatnio osiągnięty',
    veridionMcpConnected: 'połączony',
    veridionMcpUnreachable: 'nieosiągalny',
    veridionMcpDisabled: 'wyłączony',
    veridionMcpEmpty: 'Brak skonfigurowanych serwerów MCP.',
    veridionActivityTitle: 'Strumień aktywności',
    veridionActivitySubtitle: 'Ustrukturyzowane zdarzenia wykonania z orkiestratora i jego narzędzi.',
    veridionActivityEmpty: 'Nie zarejestrowano jeszcze aktywności.',
    veridionActivitySource: 'Źródło',
    veridionActivitySurface: 'Powierzchnia',
    veridionActivityEvent: 'Zdarzenie',
    veridionActivityTool: 'Narzędzie',
    veridionActivityStatus: 'Status',
    veridionActivitySummary: 'Podsumowanie',
    veridionUnavailable: 'Veridion jest obecnie niedostępny.',
    veridionNotConfigured: 'Veridion nie jest jeszcze w pełni skonfigurowany w runtime Homepage.',
    veridionRequestFailed: 'Veridion nie wykonał poprawnie żądanego wywołania administracyjnego.',
    companyTitle: 'Veridion pAIoneer Labs GmbH',
    companySubtitle: 'Instancja Veridion firmy pAIoneer Labs GmbH dla pracowników w Webex, z YouTrack i własną bazą wiedzy; jej wywołania modeli przechodzą przez Envoy AI Gateway.',
    companyWorkloads: 'Obciążenia',
    companyTokensWindow: 'Tokeny w bieżącym oknie',
    companyBudget: 'Budżet',
    companyBudgetDefault: 'budżet domyślny',
    companyCost30: 'Koszt z ostatnich 30 dni',
    openrouterTitle: 'Rozliczone przez OpenRouter',
    openrouterRemaining: 'Pozostały kredyt',
    openrouterOf: 'z',
    openrouterToday: 'Dzisiaj',
    openrouterWeek: 'W tym tygodniu',
    openrouterMonth: 'W tym miesiącu',
    openrouterUnavailable: 'OpenRouter jest teraz nieczytelny',
    openrouterNote: 'Rozliczenie OpenRouter dla klucza platformy, w dolarach amerykańskich; dzień i tydzień według UTC. Zaksięgowane wartości poniżej liczą tylko odpowiedzi podające swój koszt, dlatego są niższe.',
    companyRequests30: 'Wywołania modelu z ostatnich 30 dni',
    companyCostNote: 'Koszt w dolarach amerykańskich zgodnie z raportem OpenRouter dla każdego żądania; tokeny Envoy AI Gateway księguje na tożsamość {identity}.',
    companyCostNotReported: 'nie zgłoszono',
    companyPartUnavailable: 'nieosiągalne',
    companyWebexTitle: 'Bot Webex',
    companyWebexSubtitle: 'Webex wywołuje webex.paioneer-labs.eu/hook; most sprawdza podpis i nadawcę i przekazuje do Veridion tylko dozwolone wiadomości.',
    companyWebexBot: 'Bot',
    companyWebexWebhook: 'Webhook',
    companyWebexRegistered: 'zarejestrowany',
    companyWebexNotRegistered: 'niezarejestrowany',
    companyWebexAccess: 'Dozwoleni',
    companyWebexAnswered: 'Odpowiedziane',
    companyWebexRejected: 'Odrzucone',
    companyWebexFailed: 'Nieudane',
    companyWebexRecent: 'Ostatnie dostarczenia',
    companyWebexTime: 'Czas',
    companyWebexOutcome: 'Wynik',
    companyWebexReason: 'Powód',
    companyWebexSender: 'Nadawca',
    companyWebexEmpty: 'Brak dostarczeń od ostatniego uruchomienia.',
    companyWebexNotConfigured: 'Most Webex jest nieosiągalny lub w API administracyjnym brakuje jego klucza statusu.',
    companyUsageTitle: 'Użycie według osoby',
    companyUsageSubtitle: 'Wywołania modelu, tokeny i koszt z ostatnich 30 dni z rejestru użycia instancji.',
    companyUsagePerson: 'Osoba',
    companyUsageCalls: 'Wywołania',
    companyUsageTokens: 'Tokeny',
    companyUsageCost: 'Koszt (USD)',
    companyUsageEmpty: 'Brak wywołań modelu w ciągu ostatnich 30 dni.',
    companyWebexSendTitle: 'Napisz jako bot',
    companyWebexSendPerson: 'Do osoby',
    companyWebexSendRoom: 'Do pokoju bota',
    companyWebexSendEmail: 'Adres e-mail w Webex',
    companyWebexSendText: 'Wiadomość (Markdown)',
    companyWebexSendButton: 'Wyślij',
    companyWebexSendDone: 'Wysłano.',
    companyWebexSendFailed: 'Niepowodzenie',
    companyWebexRooms: 'Pokoje bota',
    companyWebexRoomGroup: 'grupa',
    companyWebexRoomDirect: 'bezpośredni',
    companyWebexRoomsEmpty: 'Bot nie jest jeszcze w żadnym pokoju.',
    companyKnowledgeTitle: 'Baza wiedzy',
    companyKnowledgeSubtitle: 'Dokumenty bazy wiedzy instancji firmowej (Agentic RAG); orkiestrator przeszukuje je, gdy wymaga tego krok rozmowy. Phoenix rejestruje każde wyszukiwanie.',
    companyKnowledgeDocument: 'Dokument',
    companyKnowledgeSize: 'Rozmiar',
    companyKnowledgeModified: 'Dodano',
    companyKnowledgeDelete: 'Usuń',
    companyKnowledgeDeleteConfirm: 'Usunąć {name} z bazy wiedzy?',
    companyKnowledgeUpload: 'Dodaj dokument',
    companyKnowledgeUploading: 'Przesyłanie …',
    companyKnowledgeIntake: 'Przetwarzanie',
    companyKnowledgePhoenix: 'Explainable AI (Phoenix)',
    companyKnowledgeEmpty: 'Baza wiedzy jest pusta.',
    companyKnowledgeNotConfigured: 'Baza wiedzy nie jest podłączona do API administracyjnego.',
    companyGuestsTitle: 'Goście z dostępem',
    companyGuestsHint: 'Każdy adres w {domains} może korzystać z bota. Pojedyncze adresy zewnętrzne administratorzy dodają tutaj; zmiana działa od razu.',
    companyGuestsEmail: 'Adres e-mail',
    companyGuestsAdd: 'Dodaj',
    companyGuestsRemove: 'Usuń',
    companyGuestsRemoveConfirm: 'Odebrać {email} dostęp do bota?',
    companyGuestsAddedBy: 'Dodane przez',
    companyGuestsAddedAt: 'Dodano',
    companyGuestsEmpty: 'Brak gości.',
    companyGuestsNotPersistent: 'Lista nie jest zapisywana: most nie ma katalogu danych.',
    companyGuestsLoadFailed: 'Zapisanej listy nie dało się odczytać; do następnej zmiany żaden gość nie ma dostępu.',
    companyErrorRecipientNotAllowed: 'Ten adres nie może odpowiadać botowi. Najpierw dodaj go jako gościa, potem wyślij.',
    companyErrorDomainAllowed: 'Adresy z tej domeny mają już dostęp.',
    companyErrorInvalidEmail: 'Nieprawidłowy adres e-mail.',
    companyErrorAlreadyListed: 'Ten adres jest już na liście.',
    companyErrorStoreUnwritable: 'Nie udało się zapisać listy.',
    smtmFilterTitle: 'Filtr instrumentów SMTM',
    smtmFilterSubtitle: 'Puste pole pokazuje wszystkie instrumenty; kilka nazw instrumentów oddziela się przecinkami, na przykład EUR-USD_FOREX_intraday_data_l1,BitcoinEUR_CRYPTO_intraday_data_l1.',
    smtmFilterPlaceholder: 'Nazwy instrumentów, oddzielone przecinkami',
    smtmFilterApply: 'Zastosuj filtr',
    smtmFilterClear: 'Wyczyść filtr',
    smtmReportingTitle: 'Raportowanie sygnałów SMTM',
    smtmReportingSubtitle: 'Pokazuje kwalifikowane sygnały kupna, ocenę ich wyjścia i status dostarczenia automatycznych powiadomień.',
    smtmReportingUnavailable: 'Raportowanie SMTM niedostępne',
    smtmReportingQualifiedSignals: 'Sygnały kwalifikowane',
    smtmReportingOpenSignals: 'Sygnały otwarte',
    smtmReportingResolvedSignals: 'Sygnały rozliczone',
    smtmReportingWins: 'Trafienia',
    smtmReportingLosses: 'Straty',
    smtmReportingWinRate: 'Skuteczność',
    smtmReportingAverageActualReturn: 'Średni zwrot rzeczywisty',
    smtmReportingNetActualReturn: 'Zwrot rzeczywisty netto',
    smtmReportingDeliveryFailed: 'Nieudane dostarczenia',
    smtmReportingEntryTime: 'Czas wejścia',
    smtmReportingExitTime: 'Czas wyjścia',
    smtmReportingExpectedReturn: 'Zwrot oczekiwany',
    smtmReportingActualReturn: 'Zwrot rzeczywisty',
    smtmReportingSignalStatus: 'Status sygnału',
    smtmReportingNoSignals: 'Nie zapisano jeszcze kwalifikowanych sygnałów.',
    smtmReportingPendingDeliveries: 'Oczekujące dostarczenia',
    smtmReportingFailedDeliveries: 'Nieudane dostarczenia',
    smtmReportingDeliveryError: 'Błąd dostarczenia',
    smtmTrainingTitle: 'Trening i modele SMTM',
    smtmTrainingSubtitle: 'Pokazuje jakość treningu, stan modeli i artefakty opublikowane przez usługę treningową.',
    smtmTrainingUnavailable: 'Trening SMTM niedostępny',
    smtmTrainingModels: 'Modele',
    smtmTrainingOnlineModels: 'Modele online',
    smtmTrainingFailedModels: 'Modele nieudane',
    smtmTrainingStaleModels: 'Modele przeterminowane',
    smtmTrainingAverageMae: 'Średnie MAE',
    smtmTrainingAverageRmse: 'Średnie RMSE',
    smtmTrainingAverageR2: 'Średnie R²',
    smtmTrainingAverageMase: 'Średnie MASE',
    smtmTrainingAverageHitRate: 'Średnia trafność kierunku',
    smtmTrainingHitRate: 'Trafność kierunku',
    smtmTrainingLastSuccess: 'Ostatni udany trening',
    smtmTrainingResolution: 'Rozdzielczość / horyzont',
    smtmTrainingConsoleTitle: 'Konsola treningu SMTM',
    smtmTrainingConsoleSubtitle: 'Podgląd na żywo wyjścia usługi treningowej.',
    smtmTrainingConsoleUnavailable: 'Konsola treningu SMTM niedostępna',
    smtmTrainingConsoleEmpty: 'Brak wyjścia treningu.',
    smtmRuntimeTitle: 'Runtime SMTM',
    smtmRuntimeSubtitle: 'Globalny horyzont, stan przebudowy i bramka prognoz działającego systemu SMTM.',
    smtmRuntimeUnavailable: 'Runtime SMTM niedostępny',
    smtmRuntimeForecastHorizon: 'Horyzont prognozy',
    smtmRuntimeResolution: 'Rozdzielczość',
    smtmRuntimeConfigVersion: 'Wersja konfiguracji',
    smtmRuntimePredictionGate: 'Bramka prognoz',
    smtmRuntimeRebuild: 'Przebudowa',
    smtmRuntimeStateOpen: 'otwarta',
    smtmRuntimeStateClosed: 'zamknięta',
    smtmRuntimeStateActive: 'aktywna',
    smtmRuntimeStateIdle: 'bezczynna',
    smtmRuntimeForecastHorizonMinutes: 'Minuty horyzontu prognozy',
    smtmRuntimeResolutionMinutes: 'Minuty rozdzielczości',
    smtmRuntimeRequireCompletedBars: 'Wymagaj zamkniętych świec',
    smtmRuntimePredictionGateOpen: 'Bramka prognoz otwarta',
    smtmRuntimeRebuildActive: 'Przebudowa aktywna',
    smtmRuntimeSaving: 'Zapisywanie runtime...',
    smtmRuntimeSave: 'Zapisz ustawienia runtime',
    smtmRuntimeReset: 'Odrzuć zmiany runtime',
    smtmRuntimeSaved: 'Ustawienia runtime SMTM zapisane.',
    smtmTrainingRows: 'Wiersze treningowe / testowe',
    smtmTrainingMetrics: 'Metryki',
    smtmTrainingIssues: 'Problemy treningu',
    smtmTrainingLlmFeatures: 'Cechy LLM',
    smtmTrainingNoModels: 'Brak modeli treningowych w pamięci podręcznej.',
    smtmDirection: 'Kierunek',
    smtmSentiment: 'Sentyment',
    smtmDeliveryStage: 'Etap',
    smtmDeliveryRecipient: 'Odbiorca',
    mailSettingsSaved: 'Konfiguracja poczty zapisana.',
    mailTestSent: 'Wiadomość testowa wysłana.',
    userCreatedSuccess: 'Użytkownik utworzony pomyślnie.',
    userUpdatedSuccess: 'Użytkownik zaktualizowany pomyślnie.',
    userDeletedSuccess: 'Użytkownik usunięty pomyślnie.',
    deleteUser: 'Usuń użytkownika',
    roleLabels: {
      admin: 'Administrator',
      pro: 'Pro',
      tester: 'Tester',
      user: 'Użytkownik'
    },
    statusLabels: {
      pending_email_verification: 'Oczekuje na weryfikację e-mail',
      pending_mfa: 'Oczekuje na 2FA',
      active: 'Aktywny',
      locked: 'Zablokowany',
      disabled: 'Wyłączony'
    }
  },
  footer: { managingDirectors: 'Dyrektorzy zarządzający', servicesTitle: 'Usługi', legal: { title: 'Informacje prawne', imprint: 'Nota prawna', privacy: 'Polityka prywatności', aiTransparency: 'Przejrzystość w zakresie AI', cookieSettings: 'Ustawienia plików cookie', terms: 'Warunki korzystania z usług' }, copyright: 'Wszelkie prawa zastrzeżone.' },
  auth: { validating: 'Walidacja...', errors: { registrationFailed: 'Rejestracja nieudana: ', unknownError: 'Nieznany błąd' } },
  account: { username: 'Nazwa użytkownika', email: 'E-mail', roles: 'Role', manageText: 'Hasło, uwierzytelnianie dwuskładnikowe, aktywne sesje i adres e-mail zmienisz w zarządzaniu kontem.', manageButton: 'Otwórz zarządzanie kontem', signedOut: 'Nie jesteś zalogowany.' },
  cookies: {
    title: 'Ustawienia prywatności',
    description: 'Analizujemy statystyki odwiedzin metodami uczenia maszynowego, aby ulepszać naszą stronę. Za Twoją zgodą przetwarzamy w tym celu dane o korzystaniu i urządzeniu, w tym Twój adres IP, oraz rozpoznajemy Twoją przeglądarkę przy kolejnych wizytach. Zgoda jest dobrowolna i można ją w każdej chwili wycofać w „{settings}”. Szczegóły, także dotyczące przekazywania danych do państw trzecich, zawiera polityka prywatności.',
    necessary: {
      title: 'Niezbędne',
      description: 'Wymagane do działania strony, np. wybór języka i zapisanie tego wyboru.'
    },
    statistics: {
      title: 'Statystyka',
      description: 'Odsłony stron i korzystanie ze strony, bez rozpoznawania i bez zapisywania adresu IP.'
    },
    marketing: {
      title: 'Analiza i uczenie maszynowe',
      description: 'Rozpoznawanie przy kolejnych wizytach oraz analiza adresu IP (przybliżona lokalizacja, operator sieci, organizacja) i cech urządzenia; przechowywane do dwunastu miesięcy od ostatniej wizyty. Twój adres IP jest przy tym przekazywany również do rejestrów internetowych w USA, Australii i na Mauritiusie, dla których nie stwierdzono odpowiedniego poziomu ochrony danych; istnieje ryzyko dostępu tamtejszych organów oraz utrudnionego dochodzenia Twoich praw.'
    },
    acceptAll: 'Akceptuj wszystkie',
    rejectAll: 'Tylko niezbędne',
    settings: 'Ustawienia',
    save: 'Zapisz wybór',
    alwaysOn: 'Zawsze aktywne'
  },
  pages: {
    teaching: { hero: { title: 'Szkolenia z edge AI i EU AI Act', subtitle: 'Doradztwo AI dla przedsiębiorstw • rozwój rozwiązań edge • wdrożenia zgodne z prawem' }, intro: 'Specjalistyczne szkolenia z AI dla kadry zarządzającej, kierowników projektów i zespołów programistycznych. Od doradztwa strategicznego po wdrożenie techniczne – zgodnie z EU AI Act.', eu_ai_act: { title: 'Zgodność z EU AI Act i edge computing', subtitle: 'Bezpieczne prawnie wdrażanie AI z lokalnym przetwarzaniem danych', description: 'EU AI Act wyznacza surowe zasady stosowania sztucznej inteligencji w Europie. Edge computing jest tu idealnym rozwiązaniem: wrażliwe dane pozostają lokalnie, zapewnienie zgodności staje się prostsze, a kontrola nad systemami AI pozostaje w Twoich rękach.', benefits: ['Ochrona danych dzięki lokalnemu przetwarzaniu', 'Mniejsza złożoność zapewniania zgodności', 'Pełna kontrola nad decyzjami AI', 'Przejrzystość i identyfikowalność', 'Zminimalizowane ryzyko prawne', 'Niezależność od dostawców chmury'], highlight: 'Edge computing + EU AI Act = bezpieczna prawnie AI bez kompromisów' }, offerings: { title: 'Oferta szkoleń', categories: [{ title: 'Sztuczna inteligencja i uczenie maszynowe', icon: 'brain', topics: ['Generatywna AI i duże modele językowe (edge i chmura)', 'Klasyczne uczenie maszynowe (zoptymalizowane pod edge)', 'Uczenie głębokie i sieci neuronowe (wdrożenia edge)', 'Widzenie komputerowe i NLP (rozwiązania działające na edge)', 'Systemy RAG i dostrajanie LLM (edge i chmura)', 'Autonomiczni agenci AI (edge computing)', 'Zgodność z EU AI Act i pewność prawna'] }, { title: 'Data science i statystyka', icon: 'chart', topics: ['Statystyka opisowa i wnioskowanie statystyczne', 'Modelowanie i analiza danych', 'Analiza szeregów czasowych', 'Ekonometria dla nauk ekonomicznych', 'Biostatystyka dla nauk przyrodniczych', 'Testy A/B i planowanie eksperymentów'] }, { title: 'Architektura oprogramowania i bezpieczeństwo', icon: 'shield', topics: ['Architektury modularne', 'Luźne powiązania (loose coupling) i czysty kod', 'Projektowanie mikroserwisów', 'Bezpieczeństwo IT i zgodność z przepisami', 'DevOps i CI/CD', 'Architektury chmurowe'] }] }, target_groups: { title: 'Grupy docelowe', groups: [{ title: 'Kadra zarządzająca i decydenci', description: 'Strategiczne doradztwo w zakresie AI, analiza kosztów i decyzje inwestycyjne', formats: ['Briefingi dla kadry zarządzającej', 'Analizy ROI', 'Doradztwo strategiczne'], focus: 'Uzasadnienia biznesowe, zgodność z EU AI Act, planowanie budżetu' }, { title: 'Kierownicy projektów i menedżerowie', description: 'Zarządzanie projektami AI, wybór technologii i strategie wdrożenia', formats: ['Warsztaty dla menedżerów', 'Oceny technologii', 'Opracowanie mapy drogowej'], focus: 'Planowanie projektu, wybór dostawców, zarządzanie ryzykiem' }, { title: 'Programiści i inżynierowie IT', description: 'Praktyczne tworzenie rozwiązań edge AI, implementacja techniczna i wdrożenie', formats: ['Pogłębione sesje techniczne', 'Przeglądy kodu', 'Warsztaty architektoniczne'], focus: 'Edge computing, dostrajanie LLM, integracja systemów' }, { title: 'Pracownicy działów merytorycznych', description: 'Zrozumienie AI, techniki promptowania i praktyczne zastosowanie w codziennej pracy', formats: ['Szkolenia dla użytkowników', 'Warsztaty z promptowania', 'Opracowywanie przypadków użycia'], focus: 'Praktyczne zastosowanie, integracja z przepływami pracy, wzrost produktywności' }, { title: 'Studenci i środowisko akademickie', description: 'Dydaktyka akademicka, korepetycje i opieka nad projektami naukowymi', formats: ['Wykłady', 'Tutoring', 'Opieka nad pracami dyplomowymi'], focus: 'Statystyka, ekonometria, metody badawcze' }] }, expertise: { title: 'Kompetencje techniczne', items: ['Opracowywanie strategicznych map drogowych AI dla przedsiębiorstw', 'Systemy edge AI z architekturami RAG/GRAG i dostrajaniem LoRA/QLoRA', 'Strategie zgodności z EU AI Act i bezpieczne prawnie wdrożenia', 'Analizy ROI i planowanie inwestycji w projekty AI', 'Autonomiczni agenci AI z zestawami narzędzi i zdolnością wnioskowania', 'Zarządzanie zmianą przy wdrażaniu AI w organizacjach', 'Strategie chmurowe i on-premises (Azure, STACKIT)', 'Inżynieria promptów i optymalizacja przepływów pracy'] }, technologies: { title: 'Stos technologiczny', list: 'Python, R, PyTorch, TensorFlow, CUDA, Docker, React, Azure, STACKIT, JupyterLab, Google Colab, Hugging Face, SPSS, Stata' }, clients: { title: 'Branże i instytucje', sectors: ['Ubezpieczenia zdrowotne', 'Wydawnictwa', 'Banki i fintech', 'Przemysł i IoT', 'Badania i uczelnie', 'Doradztwo', 'Start-upy'] }, workshops: { title: 'Formaty szkoleń', formats: [{ title: 'Briefing dla kadry zarządzającej', duration: '2-4 godziny', description: 'Strategiczny przegląd dla kierownictwa z naciskiem na ROI i EU AI Act' }, { title: 'Warsztat dla menedżerów', duration: '1-2 dni', description: 'Szkolenie dla kierowników projektów z wdrażania AI i zarządzania zmianą' }, { title: 'Pogłębiona sesja techniczna', duration: '2-5 dni', description: 'Praktyczne tworzenie rozwiązań edge AI dla zespołów IT i inżynierów' }, { title: 'Szkolenie dla użytkowników', duration: '0,5-1 dnia', description: 'Praktyczne zastosowanie AI dla pracowników działów merytorycznych' }, { title: 'Coaching indywidualny', duration: 'Według potrzeb', description: 'Indywidualna opieka i wsparcie w projektach' }] }, sidebar: {languagesLabel: 'Języki:', languagesValue: 'DE / EN / NL', focusLabel: 'Tematyka:', specializationTitle: 'Specjalizacja', specializationItems: ['Edge AI do lokalnego przetwarzania danych bez zależności od chmury', 'Wdrożenia zgodne z EU AI Act, zapewniające pewność prawną'], benefitsTitle: 'Korzyści', benefits: ['Dopasowane do grupy docelowej', 'Gotowe do natychmiastowego zastosowania', 'Ukierunkowane na ROI', 'Zdalnie lub na miejscu'] }, cta: { title: 'Czas na strategiczną transformację AI?', description: 'Od doradztwa dla kadry zarządzającej po wdrożenie techniczne – porozmawiajmy o Twoich konkretnych wymaganiach.', button: 'Poproś o konsultację', email: 'info@paioneer.eu', subject: 'Zapytanie o szkolenie' } },
    agenticdev: { seo: { title: 'Intent-Driven Development (IDD) dla Agentic Coding | pAIoneer Labs GmbH', description: 'Intent-Driven Development pozwala sterować wytwarzaniem oprogramowania wspomaganym przez AI: sens, decyzje i scenariusze stają się operacyjnymi artefaktami dla Agentic Coding.', keywords: 'Intent-Driven Development, Intent Driven Development, IDD, Agentic Coding, agentowe wytwarzanie oprogramowania, wytwarzanie oprogramowania wspomagane przez AI, Vibe Coding, Spec-Driven Development, inżynieria promptów, inżynieria wymagań z AI', ogTitle: 'Intent-Driven Development: sens przed implementacją', ogDescription: 'IDD operacjonalizuje kontekst, zanim powstanie kod: Intent, Decisions i Scenarios stają się pamięcią projektu w agentowym wytwarzaniu oprogramowania.', twitterTitle: 'Intent-Driven Development (IDD) dla Agentic Coding', twitterDescription: 'Kod pod kontrolą zamiast chaosu promptów: IDD zamienia sens, decyzje i scenariusze w operacyjne artefakty.', url: 'https://paioneer-labs.eu/agenticdev', structuredData: { '@context': 'https://schema.org', '@type': 'Service', name: 'Intent-Driven Development (IDD) dla Agentic Coding', serviceType: 'Agentowe wytwarzanie oprogramowania i procesy wytwórcze wspomagane przez AI', description: 'Doradztwo i wdrożenia w zakresie Intent-Driven Development, IDD Vaults, przepływów pracy Agentic Coding oraz weryfikowalnego wytwarzania oprogramowania wspomaganego przez AI.', provider: { '@type': 'Organization', name: 'pAIoneer Labs GmbH', url: 'https://paioneer-labs.eu' }, areaServed: 'DE, NL, EU', url: 'https://paioneer-labs.eu/agenticdev' } }, hero: { eyebrow: 'Agentic Coding wymaga jawnego kontekstu', title: 'Intent-Driven Development', claim: 'Sens przed implementacją.', lead: 'AI pisze kod. IDD dba o to, by pracowała nad właściwym problemem. Intent-Driven Development zamienia cele, granice, decyzje i scenariusze w operacyjne artefakty agentowego wytwarzania oprogramowania.' }, implicitContextProblem: { title: 'Ryzykiem jest niejawny kontekst', intro: 'Prawdziwym ryzykiem w wytwarzaniu oprogramowania wspomaganym przez AI nie jest brak kodu. Ryzykiem jest kontekst, który pozostaje ukryty w czyjejś głowie, w historii czatu lub w rozproszonych zgłoszeniach.', items: [{ title: 'Niejasne zadanie', description: 'Prompty często opisują rozwiązanie, ale nie cel, cele wykluczone, kryteria sukcesu i założenia. AI pracuje wtedy szybko, ale niekoniecznie we właściwym kierunku.' }, { title: 'Przypadkowa architektura', description: 'Decyzje technologiczne zapadają mimochodem: o utrwalaniu danych, wyborze modelu, przypadkach błędów i eksploatacji rozstrzyga się niejawnie, zamiast świadomie tymi decyzjami kierować.' }, { title: 'Nieweryfikowalny wynik', description: 'Bez scenariuszy i kryteriów akceptacji pozostaje niejasne, czy kod naprawdę działa poprawnie, czy tylko wygląda wiarygodnie.' }], resolution: 'IDD rozwiązuje właśnie ten problem: najpierw operacjonalizuje się sens, a dopiero potem wyprowadza z niego kod.' }, antiVibeCoding: { title: 'Vibe Coding nie jest procesem wytwarzania oprogramowania', description: 'Do demonstracji intuicja może wystarczyć. W przypadku oprogramowania, które wiąże się z eksploatacją, utrzymaniem, bezpieczeństwem, kosztami i odpowiedzialnością, to za mało. Agenci nie potrzebują więcej nastroju, lecz jawnego kontekstu.', contrasts: ['Vibe Coding tworzy ruch. IDD nadaje kierunek.', 'Promptowanie daje odpowiedzi. IDD tworzy pamięć projektu.', 'Agentic Coding bez IDD pozostaje aktywnością. Agentic Coding z IDD staje się wytwarzaniem oprogramowania pod kontrolą.'] }, principle: { title: 'Dokumentacja nie jest produktem ubocznym', thesis: 'W IDD dokumentacja jest artefaktem operacyjnym.', description: 'Dokumentacja nie służy sprawozdawczości. Jest przestrzenią roboczą, w której cele, granice, decyzje i oczekiwane zachowanie stają się jawne, zanim agenci przystąpią do implementacji.', pillarsTitle: 'Intent. Decisions. Scenarios. Code.', pillarsIntro: 'IDD nie sprowadza wytwarzania oprogramowania do promptów. Ujawnia sens przedsięwzięcia i wyprowadza z niego weryfikowalną implementację.', pillars: [{ title: 'Intent', description: 'Co ma zostać osiągnięte, co wyraźnie pozostaje poza zakresem i po czym poznamy sukces?' }, { title: 'Decisions', description: 'Jakie ważne decyzje podjęto, w jakim kontekście i z jakimi konsekwencjami?' }, { title: 'Scenarios', description: 'Jakiego zachowania oczekujemy w przypadkach typowych i brzegowych, w przypadkach błędów oraz w sytuacjach akceptacyjnych?' }, { title: 'Code', description: 'Implementacja powstaje z udokumentowanego sensu i jest sprawdzana względem scenariuszy i kroków weryfikacji.' }] }, vault: { title: 'IDD Vault: pamięć projektu zamiast historii promptów', description: 'IDD Vault przechowuje istotny kontekst tam, gdzie agenci i ludzie mogą z niego ponownie skorzystać. Nie więcej plików, niż to konieczne. Każdy plik ma jasną funkcję.', rule: 'Niewiele artefaktów. Jasna funkcja. Trwały kontekst.', effect: 'Vault zapobiega znikaniu decydującego kontekstu w czacie, w czyjejś głowie lub w rozproszonych zgłoszeniach.', treeLines: ['/project', '  /idd_vault', '    intent.md       # cel, cele wykluczone, kryteria sukcesu, założenia', '    decisions.md    # decyzje z kontekstem, uzasadnieniem i konsekwencjami', '    scenarios.md    # zachowanie, przypadki brzegowe, kryteria akceptacji', '  /code', '  AGENTS.md         # reguły i oczekiwania wobec agentów kodujących', '  README.md         # punkt wejścia, konfiguracja, tryb pracy, granice'] }, outputs: { title: 'Nie tekst. Kod pod kontrolą.', description: 'Pliki IDD nie są raportem. Są wejściem do konkretnej pracy implementacyjnej i do zwrotnego wprowadzania wniosków do projektu.', items: [{ file: 'intent.md', result: 'Zakres', description: 'Endpointy, model danych, kryteria sukcesu, cele wykluczone i założenia stają się widoczne jako ramy prac.' }, { file: 'decisions.md', result: 'Architektura', description: 'Technologia, eksploatacja, utrwalanie danych, wybór modelu i kompromisy są uzasadniane, a nie rozstrzygane mimochodem.' }, { file: 'scenarios.md', result: 'Testy', description: 'Testy akceptacyjne, przypadki błędów, zmiany stanu i przypadki brzegowe powstają przed implementacją lub w jej trakcie.' }, { file: 'AGENTS.md', result: 'Jakość kodu', description: 'Reguły, wzorce, ograniczenia, migracje, OpenAPI i oczekiwane wyniki stają się dla agentów jawne.' }, { file: 'README.md', result: 'Punkt wejścia', description: 'Konfiguracja, tryb pracy, granice i przykładowe przebiegi pozostają zrozumiałe dla ludzi i agentów.' }, { file: 'Code', result: 'Pętla zwrotna', description: 'Wnioski z implementacji i weryfikacji wracają do Vault, testów i kolejnej iteracji.' }] }, comparison: { title: 'IDD zaczyna się przed specyfikacją', intro: 'Spec-Driven Development sprawdza się wtedy, gdy cel jest już technicznie precyzyjny i stabilny. IDD zaczyna wcześniej: tam, gdzie dziedzinę, założenia, kompromisy i przypadki błędów trzeba dopiero ujawnić.', columns: ['Podejście', 'Punkt ciężkości', 'Mocna strona', 'Ograniczenie'], rows: [{ approach: 'Promptowanie', center: 'Dane wejściowe dla modelu', strength: 'Szybkie i bezpośrednie', limit: 'Ulotne, niepełne i trudne do zweryfikowania' }, { approach: 'Vibe Coding', center: 'Intuicja i iteracja', strength: 'Przydatne do eksperymentów i demonstracji', limit: 'Brak wiarygodnej kontroli nad oprogramowaniem, za które trzeba odpowiadać' }, { approach: 'Spec-Driven Development', center: 'Kontrakt techniczny', strength: 'Spójność z już zdefiniowaną specyfikacją', limit: 'Niewłaściwy problem można zaimplementować formalnie poprawnie' }, { approach: 'Intent-Driven Development', center: 'Sens, cel i decyzje', strength: 'Wyjaśnia kontekst, kompromisy i granice przed implementacją', limit: 'Wymaga konsekwentnego utrzymywania kontekstu i walidacji' }], summary: 'Specyfikacje mówią, co musi być technicznie spełnione. IDD uzasadnia, dlaczego należy budować właśnie w tym kierunku.' }, workflow: { title: 'Wyjaśnić. Zdecydować. Sformułować. Zbudować. Uwzględnić wnioski.', description: 'IDD to nie model kaskadowy. IDD to małe, kontrolowane iteracje z trwałym kontekstem.', steps: [{ title: 'Wyjaśnić intencję', description: 'Cele, cele wykluczone, kryteria sukcesu i założenia stają się widoczne, zanim powstanie kod.' }, { title: 'Udokumentować decyzje', description: 'Decyzje architektoniczne i produktowe są zapisywane wraz z kontekstem, uzasadnieniem i konsekwencjami.' }, { title: 'Sformułować scenariusze', description: 'Typowe zachowanie, przypadki brzegowe, przypadki błędów i kryteria akceptacji są opisywane w weryfikowalnej formie.' }, { title: 'Powierzyć implementację agentom', description: 'Agenci AI pracują na podstawie jawnego kontekstu, a nie odizolowanych promptów.' }, { title: 'Zweryfikować i uwzględnić wnioski', description: 'Wnioski z kodu, testów i eksploatacji aktualizują Vault i kolejną iterację.' }] }, impact: { title: 'Dlaczego ma to znaczenie w prawdziwych projektach', description: 'Dzięki IDD wytwarzanie oprogramowania wspomagane przez AI daje się połączyć z pracą zespołów, eksploatacją i zapewnieniem jakości.', items: ['Mniej poprawek, bo cele i cele wykluczone są widoczne.', 'Lepsza architektura, bo decyzje są uzasadniane.', 'Lepsze testy, bo scenariusze powstają przed kodem.', 'Lepsza współpraca, bo kontekst nie znika w czacie.', 'Lepsze wyniki agentów, bo każdy krok opiera się na jawnych artefaktach.'] }, contact: { title: 'Wprowadź IDD do agentowych procesów wytwarzania oprogramowania', description: 'Jeśli wytwarzanie oprogramowania wspomagane przez AI ma być czymś więcej niż eksperymentem, potrzebuje operacyjnego modelu kontekstu.', details: 'Pomagamy budować IDD Vaults, reguły dla agentów, scenariusze i weryfikowalne przepływy pracy.', button: 'Porozmawiajmy o IDD', subject: 'Rozmowa o Intent-Driven Development', email: 'info@paioneer.eu' } },
    impressum: injectPersonalData('pl', baseTranslationPL)
  }
};
